let lookbookCurrentSlide = 0;
    let lastToolSlide = 0; // remembers where the customer was in the selection tool (Track A) before visiting a reference slide

    // ===== AUTOSAVE / RESTORE (survives refresh, browser issues, accidental back) =====
    const AUTOSAVE_KEY = 'nc_lookbook_progress_v1';

    function saveProgress() {
      try {
        const fieldValues = {};
        document.querySelectorAll('.review-field-input, #contactName, #contactPhone, #contactEmail, #contactServiceDate, #contactOrderNumber, #contactNotes').forEach(el => {
          if (el.id) {
            fieldValues[el.id] = el.value;
          } else {
            const key = (el.dataset.field || '') + '|' + (el.dataset.pageId || '') + '|' + (el.className.includes('oos-what') ? 'what' : el.className.includes('oos-who') ? 'who' : '');
            fieldValues[key] = el.value;
          }
        });
        const state = {
          selectedTier,
          pageBudget,
          selectedPages,
          selectedFormat,
          currentSlide: lookbookCurrentSlide,
          fieldValues,
          savedAt: Date.now()
        };
        localStorage.setItem(AUTOSAVE_KEY, JSON.stringify(state));
      } catch (e) {
        // localStorage unavailable (private browsing, etc.) — fail silently, nothing to do about it
      }
    }

    function clearSavedProgress() {
      try { localStorage.removeItem(AUTOSAVE_KEY); } catch (e) {}
    }

    function loadSavedProgress() {
      try {
        const raw = localStorage.getItem(AUTOSAVE_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    }

    function restoreProgress(externalState) {
      const state = externalState || loadSavedProgress();
      if (!state) return;

      if (state.selectedTier) {
        selectedTier = state.selectedTier;
        pageBudget = state.pageBudget;
        const tierCard = document.querySelector(`.tier-option[data-tier="${state.selectedTier}"]`);
        if (tierCard) tierCard.classList.add('is-chosen');
        const msg = document.getElementById('tierConfirmMsg');
        if (msg) {
          msg.textContent = `Welcome back — you've chosen a ${state.selectedTier}-page program with ${state.pageBudget} page${state.pageBudget === 1 ? '' : 's'} to fill. Your previous selections have been restored below.`;
        }
        // Only the restored tier's format group should look active.
        document.querySelectorAll('.tier-option').forEach(el => {
          const isActive = Number(el.dataset.tier) === state.selectedTier;
          const formatGroup = el.querySelector('.format-group');
          if (formatGroup) formatGroup.style.opacity = isActive ? '1' : '0.35';
        });
      }

      if (state.selectedPages) {
        selectedPages = state.selectedPages;
        Object.keys(selectedPages).forEach(pid => {
          document.querySelectorAll(`.page-select-cb[data-page-id="${pid}"]`).forEach(cb => { cb.checked = true; });
          document.querySelectorAll(`.folio-mini[data-page-id="${pid}"]`).forEach(el => { el.classList.add('is-selected'); });
        });
      }

      if (state.selectedFormat) {
        selectedFormat = state.selectedFormat;
        document.querySelectorAll('.format-option').forEach(el => {
          el.classList.toggle('is-chosen', el.dataset.format === selectedFormat);
        });
      }

      updateBudgetTrackers();
      renderReviewSlide();

      // Restore typed field values (after renderReviewSlide has rebuilt the cards)
      if (state.fieldValues) {
        Object.keys(state.fieldValues).forEach(key => {
          const val = state.fieldValues[key];
          if (!val) return;
          const byId = document.getElementById(key);
          if (byId) { byId.value = val; return; }
          // Handle oos-what / oos-who and other data-field keyed inputs
          const [field, pageId, subtype] = key.split('|');
          if (subtype === 'what' || subtype === 'who') return; // OOS table rows are rebuilt fresh; skipped intentionally for now
          if (field && pageId) {
            const el = document.querySelector(`[data-field="${field}"][data-page-id="${pageId}"]`);
            if (el) el.value = val;
          }
        });
      }

      if (typeof state.currentSlide === 'number' && lookbookSlides && lookbookSlides[state.currentSlide]) {
        showLookbookSlide(state.currentSlide);
      }
    }

    // ===== CROSS-DEVICE SAVE & RESUME (token-based, emailed link) =====
    const RESUME_API_BASE = 'https://nc-lookbook-resume.notedandcharmed.workers.dev';

    let resumeToken = null;         // set once /start succeeds, or on load if ?resume= is present
    let remoteSaveTimer = null;
    let hasSentResumeEmail = false; // guards the auto-email so it only fires once per session

    function buildProgressState() {
      const fieldValues = {};
      document.querySelectorAll('.review-field-input, #contactName, #contactPhone, #contactEmail, #contactServiceDate, #contactOrderNumber, #contactNotes').forEach(el => {
        if (el.id) {
          fieldValues[el.id] = el.value;
        } else {
          const key = (el.dataset.field || '') + '|' + (el.dataset.pageId || '') + '|' + (el.className.includes('oos-what') ? 'what' : el.className.includes('oos-who') ? 'who' : '');
          fieldValues[key] = el.value;
        }
      });
      return {
        selectedTier,
        pageBudget,
        selectedPages,
        selectedFormat,
        currentSlide: lookbookCurrentSlide,
        fieldValues,
        savedAt: Date.now()
      };
    }

    function hasMeaningfulProgress() {
      if (selectedTier) return true;
      if (Object.keys(selectedPages).length > 0) return true;
      const email = document.getElementById('contactEmail')?.value.trim();
      const name = document.getElementById('contactName')?.value.trim();
      return !!(email || name);
    }

    // Called by the "Save & finish later" button. If we already have an email
    // (either the contact field is filled, or a session already started),
    // saves immediately. Otherwise reveals a small inline box asking for one —
    // never a native browser popup, which can freeze the page and looks out
    // of place next to the rest of this custom-styled form.
    async function handleSaveButtonClick() {
      if (!hasMeaningfulProgress()) {
        showSaveStatus('Please choose a program size or select a page before saving.', true);
        return;
      }

      const emailEl = document.getElementById('contactEmail');
      const email = emailEl ? emailEl.value.trim() : '';

      if (email || resumeToken) {
        await saveAndEmailLater(email);
        return;
      }

      showInlineEmailCapture();
    }

    function showInlineEmailCapture() {
      const box = document.getElementById('inlineEmailCapture');
      const input = document.getElementById('inlineEmailInput');
      if (!box || !input) return;
      box.style.display = 'block';
      input.value = '';
      input.focus();
    }

    function cancelInlineEmailCapture() {
      const box = document.getElementById('inlineEmailCapture');
      if (box) box.style.display = 'none';
    }

    async function confirmInlineEmailAndSave() {
      const input = document.getElementById('inlineEmailInput');
      const email = input ? input.value.trim() : '';

      if (!email || !email.includes('@')) {
        if (input) { input.style.borderColor = '#e0b0b0'; input.focus(); }
        return;
      }

      // Keep the contact-info field in sync so the customer doesn't have to
      // type their email twice when they reach that slide.
      const contactEmailEl = document.getElementById('contactEmail');
      if (contactEmailEl) contactEmailEl.value = email;

      cancelInlineEmailCapture();
      await saveAndEmailLater(email);
    }

    // The actual save + email call, once an email address is known one way
    // or another (already on the contact slide, already have a session, or
    // just entered via the inline box).
    async function saveAndEmailLater(knownEmail) {
      const emailEl = document.getElementById('contactEmail');
      const email = knownEmail || (emailEl ? emailEl.value.trim() : '');

      if (!resumeToken) {
        if (!email) {
          showSaveStatus('Please enter your email so we know where to send your saved-progress link.', true);
          return;
        }
        await startRemoteSession(email);
      } else {
        await saveRemoteSession();
      }
    }

    async function startRemoteSession(email) {
      try {
        const orderNumberEl = document.getElementById('contactOrderNumber');
        const state = buildProgressState();
        const res = await fetch(`${RESUME_API_BASE}/start`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            orderNumber: orderNumberEl ? orderNumberEl.value.trim() : '',
            state
          })
        });
        if (!res.ok) { showSaveStatus('Could not save your progress remotely — you can still continue on this device.', true); return; }

        const data = await res.json();
        if (data.ok && data.token) {
          resumeToken = data.token;
          hasSentResumeEmail = true;
          showSaveStatus(data.emailed
            ? "Saved — we've emailed you a link to finish this on any device."
            : 'Saved to this device. (We could not send the confirmation email — check your email address.)');
        }
      } catch (e) {
        showSaveStatus('Could not save your progress remotely — you can still continue on this device.', true);
      }
    }

    async function saveRemoteSession() {
      try {
        const state = buildProgressState();
        const res = await fetch(`${RESUME_API_BASE}/save`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: resumeToken, state })
        });
        if (res.ok) {
          showSaveStatus('Saved.');
        }
      } catch (e) {
        // Network hiccup — fail quietly; local autosave still protects this device.
      }
    }

    async function resendResumeEmail() {
      const statusEl = document.getElementById('resumeSaveStatus');
      if (!resumeToken) {
        if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#e0b0b0'; statusEl.textContent = 'Nothing to resend yet — start filling in the form first.'; }
        return;
      }
      try {
        const res = await fetch(`${RESUME_API_BASE}/resend`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: resumeToken })
        });
        const data = await res.json();
        showSaveStatus(data.emailed ? 'Link resent — check your email.' : 'Could not resend the email right now.', !data.emailed);
      } catch (e) {
        showSaveStatus('Could not resend the email right now.', true);
      }
    }

    function showSaveStatus(message, isWarning) {
      // Two possible status elements: #resumeSaveStatus (contact info slide
      // only) and #persistentSaveStatus (present on every Track A slide).
      // Write to whichever exist so feedback is visible no matter which
      // slide the customer clicked "Save & finish later" from.
      [document.getElementById('resumeSaveStatus'), document.getElementById('persistentSaveStatus')].forEach(el => {
        if (!el) return;
        el.textContent = message;
        el.style.color = isWarning ? '#e0b0b0' : '#9ecb9e';
        el.style.display = 'block';
        clearTimeout(el._hideTimer);
        el._hideTimer = setTimeout(() => { el.style.display = 'none'; }, 5000);
      });
    }

    async function deleteProgressRemote() {
      if (!resumeToken) return;
      try {
        await fetch(`${RESUME_API_BASE}/delete`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: resumeToken })
        });
      } catch (e) {
        // Non-critical — the entry expires on its own after 60 days either way.
      }
    }

    async function checkForResumeLink() {
      const params = new URLSearchParams(window.location.search);
      const token = params.get('resume');
      if (!token) return;

      const statusEl = document.getElementById('resumeSaveStatus');
      if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#999'; statusEl.textContent = 'Loading your saved progress...'; }

      try {
        const res = await fetch(`${RESUME_API_BASE}/fetch?token=${encodeURIComponent(token)}`);
        if (!res.ok) {
          if (statusEl) { statusEl.style.color = '#e0b0b0'; statusEl.textContent = 'This link has expired or is no longer valid. Please continue below — your work will still save as you go.'; }
          return;
        }
        const data = await res.json();
        if (data.found && data.state) {
          resumeToken = token;
          hasSentResumeEmail = true;
          restoreProgress(data.state);
          if (statusEl) { statusEl.style.color = '#9ecb9e'; statusEl.textContent = 'Welcome back — your saved progress has been loaded.'; }
        }
      } catch (e) {
        if (statusEl) { statusEl.style.color = '#e0b0b0'; statusEl.textContent = 'Something went wrong loading your saved progress. Please continue below on this device.'; }
      }
    }


    // ===== TIER & PAGE SELECTION STATE =====
    let selectedTier = null;   // 4, 8, or 12
    let pageBudget = 0;        // fillable content-page slots (tier minus 2 covers)
    let selectedPages = {};    // { pageId: { title } }
    let selectedFormat = 'standard'; // 'standard' (5.5x8.5" folded) or 'tabloid' (8.5x11" folded) — defaults to standard

    function selectFormat(format, tier) {
      // Only the currently-selected tier's format choice can actually be
      // changed — clicking a format button on a tier that isn't selected
      // does nothing, since that choice wouldn't apply to anything.
      if (tier !== selectedTier) return;
      selectedFormat = format;
      document.querySelectorAll(`.format-option[data-tier="${tier}"]`).forEach(el => {
        el.classList.toggle('is-chosen', el.dataset.format === format);
      });
      saveProgress();
    }

    function selectTier(tier, cardEl) {
      selectedTier = tier;
      pageBudget = tier - 2; // covers always take 2 pages
      document.querySelectorAll('.tier-option').forEach(el => el.classList.remove('is-chosen'));
      cardEl.classList.add('is-chosen');
      const msg = document.getElementById('tierConfirmMsg');
      if (msg) {
        msg.textContent = `Great — with a ${tier}-page program, you have ${pageBudget} page${pageBudget === 1 ? '' : 's'} to fill with the pages that matter most to your family. Browse the categories below and select the pages you'd like.`;
      }
      // Clear any prior selections if tier changes so budget stays accurate
      selectedPages = {};
      document.querySelectorAll('.page-select-cb').forEach(cb => { cb.checked = false; });
      document.querySelectorAll('.folio-mini').forEach(el => el.classList.remove('is-selected'));
      // Only the selected tier's paper-size choice actually applies — dim the
      // others so it's never ambiguous which format is really in effect.
      document.querySelectorAll('.tier-option').forEach(el => {
        const isActive = Number(el.dataset.tier) === tier;
        const formatGroup = el.querySelector('.format-group');
        if (formatGroup) formatGroup.style.opacity = isActive ? '1' : '0.35';
      });
      updateBudgetTrackers();
      renderReviewSlide();
      saveProgress();
    }

    function togglePageSelect(checkbox, pageId, pageTitle) {
      if (!selectedTier) {
        checkbox.checked = false;
        alert('Please choose your program size first (see "Choose Your Size" in the jump menu) before selecting pages.');
        return;
      }
      const currentCount = Object.keys(selectedPages).length;
      if (checkbox.checked && currentCount >= pageBudget) {
        checkbox.checked = false;
        alert(`You've selected all ${pageBudget} pages included with your ${selectedTier}-page program. To add this page, please deselect another page first, or choose a larger size.`);
        return;
      }
      if (checkbox.checked) {
        selectedPages[pageId] = { title: pageTitle };
      } else {
        delete selectedPages[pageId];
      }
      // Update visual state on every matching thumbnail (same page may only appear once, but stay safe)
      document.querySelectorAll(`.folio-mini[data-page-id="${pageId}"]`).forEach(el => {
        el.classList.toggle('is-selected', !!selectedPages[pageId]);
      });
      updateBudgetTrackers();
      renderReviewSlide();
      saveProgress();
    }

    function updateBudgetTrackers() {
      const count = Object.keys(selectedPages).length;
      const trackers = document.querySelectorAll('.budget-tracker');
      trackers.forEach(t => {
        const countEl = t.querySelector('.budget-count');
        const fillEl = t.querySelector('.budget-bar-fill');
        const warnEl = document.querySelector('.no-tier-warning');
        if (!selectedTier) {
          if (countEl) countEl.textContent = 'Choose your size first';
          if (fillEl) fillEl.style.width = '0%';
          if (warnEl) warnEl.classList.add('show');
          t.classList.remove('is-full');
          return;
        }
        if (warnEl) warnEl.classList.remove('show');
        if (countEl) countEl.textContent = `${count} of ${pageBudget} pages selected`;
        const pct = pageBudget > 0 ? Math.min(100, (count / pageBudget) * 100) : 0;
        if (fillEl) fillEl.style.width = pct + '%';
        t.classList.toggle('is-full', count >= pageBudget);
      });
    }

    // ===== PAGE TYPE CLASSIFICATION (for review/detail form rendering) =====
    // 'obituary' = open text box, length checked
    // 'order-of-service' = repeatable What/Who table + pallbearers/honorary/acknowledgments + catch-all
    // 'jw-memorial-service' = Kingdom Hall memorial service structure — venue info, scripture, named parts with editable role labels, optional Zoom info
    // 'catholic-mass' = Mass of Christian Burial structure — sectioned What/Who rows (What pre-filled editable, Who blank placeholder), fixed 6-slot Pallbearers, Special Acknowledgments
    // 'homegoing-celebration' = Baptist/Homegoing order of service — same What/Who row pattern, fixed 6-slot Pallbearers, 4-slot Honorary Pallbearers, Special Acknowledgments
    // 'orthodox-burial' = Order of Christian Burial (Orthodox) — same What/Who row pattern, fixed 6-slot Pallbearers, 4-slot Honorary Pallbearers, Special Acknowledgments
    // 'military-honors' = Ceremony of Final Tribute — What/Who rows, fixed Pallbearers/Honorary, plus Honored Service Details section, Special Acknowledgments
    // 'first-responder-honors' = Ceremony of Final Tribute (fire/police) — same shape as military-honors, fire/police terminology
    // 'family-lineage' = 4-generation family tree — Generation I couple, Generations II/III flexible name lists, Generation IV grandchildren/great-grandchildren
    // 'life-sketch' = JW Life Sketch — labeled bio fields, free-text ministry privileges, Bible Version scripture picks, choice of standard or custom closing paragraph
    // 'multi-scripture' = a page with one or more fixed scripture passages + one shared Bible Version dropdown for the whole page — passage refs stay editable, page note catches anything unusual
    // 'family-gratitude' = thank-you paragraph + Burial/Interment and Gathering/Fellowship detail sections, each a flexible What/Who-style list of labeled lines, plus a closing scripture
    // 'faithful-course' = 4-photo themed collage (Public Ministry, Conventions & Assemblies, etc.) — editable theme label + caption per slot, opening/closing scripture
    // 'keep-or-replace-sections' = page with 2+ named sections (songs, scriptures, etc.) where each section can be kept as printed or fully replaced with a customer-provided alternative
    // 'collage' = photo count reminder, quote space on some layouts
    // 'photo-tributes' = up to 6 named person + their tribute words, each paired with a photo (matched by filename)
    // 'text-tribute' = open text box for scripture, prayers, tributes, poems, etc. (default/fallback type)
    const orderOfServicePageIds = new Set(['order-of-service']);
    const jwMemorialServicePageIds = new Set(['order-of-discourse']);
    const catholicMassPageIds = new Set(['mass-of-burial']);
    const homegoingCelebrationPageIds = new Set(['homegoing-celebration']);
    const orthodoxBurialPageIds = new Set(['orthodox-service']);
    const militaryHonorsPageIds = new Set(['military-honors-ii']);
    const firstResponderHonorsPageIds = new Set(['last-alarm-eow']);
    const familyLineagePageIds = new Set(['family-lineage-legacy']);
    const generationalLegacyPageIds = new Set(['generational-legacy']);
    const lifeInChurchPageIds = new Set(['life-in-church']);
    const diptychsPageIds = new Set(['diptychs']);
    const matriarchTributePageIds = new Set(['matriarch-tribute']);
    const patriarchTributePageIds = new Set(['patriarch-tribute']);
    const sacramentalLifePageIds = new Set(['sacramental-life']);
    const universalPrayerPageIds = new Set(['universal-prayer']);
    const catholicGuestWelcomePageIds = new Set(['catholic-guest-welcome']);
    const oracionesSpanishIPageIds = new Set(['oraciones-spanish-i']);
    const guadalupeDevocionSpanishPageIds = new Set(['oraciones-spanish-ii']);
    const spiritualBouquetsPageIds = new Set(['spiritual-bouquets']);
    const catholicCommittalReceptionPageIds = new Set(['catholic-committal-reception']);
    const lifeSketchPageIds = new Set(['life-sketch']);
    // Config per multi-scripture page: the fixed reference lines shown on that printed page (editable, pre-filled).
    const multiScriptureConfig = {
      'resurrection-hope': ['Revelation 21:3, 4', 'Job 14:14, 15', 'Psalm 37:11, 29'],
      'earthly-paradise': ['Isaiah 35:1', 'Isaiah 35:5, 6', 'Isaiah 65:21, 22', 'Luke 23:43', 'Psalm 37:29']
    };
    const familyGratitudePageIds = new Set(['family-gathering']);
    const faithfulCoursePageIds = new Set(['theocratic-collage']);
    // Config per keep-or-replace page: each section's label + the reference line shown as printed.
    const keepOrReplaceConfig = {
      'songs-of-praise': [
        { label: '"He Will Call"', ref: 'Song 151 — Based on Job 14:13–15' },
        { label: '"See Yourself When All Is New"', ref: 'Song 139 — Based on Revelation 21:1–5' },
        { label: 'Closing Scripture', ref: 'Psalm 104:33' }
      ]
    };
    const vigilRosaryPageIds = new Set(['vigil-rosary']);
    const inurnmentPageIds = new Set(['rite-of-inurnment']);
    const resolutionPageIds = new Set(['resolution-of-respect']);
    const serviceOfCommittalPageIds = new Set(['service-of-committal']);
    // Pages that are fixed/printed content with nothing to fill in — only the universal per-page note box applies, no generic open text box.
    const noteOnlyPageIds = new Set(['great-hymns', 'im-free-keepsake', 'patron-saints', 'trisagion-service', 'damascus-hymns', 'koliva-cycles', 'prayers-for-departed']);
    const sacredHymnodyPageIds = new Set(['sacred-hymnody-psalm-91']);
    const memoryEternalPageIds = new Set(['memory-eternal']);
    const makariaMealPageIds = new Set(['makaria-meal']);
    const panikhidaSchedulePageIds = new Set(['panikhida-schedule']);
    const psalm23PageIds = new Set(['psalm-23']);
    const eccl3John14PageIds = new Set(['eccl-3-john-14']);
    const twoTimothy4PageIds = new Set(['2-timothy-4']);
    const psalm91PageIds = new Set(['psalm-91']);
    const lordsPrayerPageIds = new Set(['lords-prayer']);
    const psalm121PageIds = new Set(['psalm-121']);
    const isaiah40Matthew11PageIds = new Set(['isaiah-40-matthew-11']);
    const romans8Rev21PageIds = new Set(['romans-8-rev-21']);
    const oneCor13TwoCor5PageIds = new Set(['1-cor-13-2-cor-5']);
    const comfortHopePageIds = new Set(['comfort-hope']);
    const prov31BeatitudesPageIds = new Set(['prov-31-beatitudes']);
    const psalm62Phil4PageIds = new Set(['psalm-62-phil-4']);
    const john11StFrancisPageIds = new Set(['john-11-st-francis']);
    const customTextPageIds = new Set(['custom-text']);
    const christianWalkPageIds = new Set(['christian-walk']);
    const ministryOfMusicPageIds = new Set(['ministry-of-music']);
    const repastFellowshipPageIds = new Set(['repast-fellowship']);
    const gratitudeExpressionsPageIds = new Set(['acknowledgments']);
    const namedCollagePageIds = new Set([]); // collage pages whose id doesn't follow the "N-up" pattern
    const photoTributePageIds = new Set(['special-tribute']);
    // Collage pages that also include a quote/verse space in their layout (confirmed page by page, not all collages have this)
    const collageWithQuotePageIds = new Set(['9-up-grid-1', '10-up-grid-3', '10-up-collage-6']);

    function isCollagePageId(pageId) {
      return /^\d+-up/.test(pageId) || namedCollagePageIds.has(pageId);
    }

    // Extracts the photo count from a collage page's id (e.g. '6-up-collage-5' -> 6).
    // Returns null for named collage pages that don't encode a count in their id,
    // so callers can fall back to generic wording rather than showing a wrong number.
    function collagePhotoCount(pageId) {
      const match = /^(\d+)-up/.exec(pageId);
      return match ? parseInt(match[1], 10) : null;
    }

    function getPageType(pageId) {
      if (pageId === 'obituary') return 'obituary';
      if (orderOfServicePageIds.has(pageId)) return 'order-of-service';
      if (jwMemorialServicePageIds.has(pageId)) return 'jw-memorial-service';
      if (catholicMassPageIds.has(pageId)) return 'catholic-mass';
      if (homegoingCelebrationPageIds.has(pageId)) return 'homegoing-celebration';
      if (orthodoxBurialPageIds.has(pageId)) return 'orthodox-burial';
      if (militaryHonorsPageIds.has(pageId)) return 'military-honors';
      if (firstResponderHonorsPageIds.has(pageId)) return 'first-responder-honors';
      if (familyLineagePageIds.has(pageId)) return 'family-lineage';
      if (generationalLegacyPageIds.has(pageId)) return 'generational-legacy';
      if (lifeInChurchPageIds.has(pageId)) return 'life-in-church';
      if (diptychsPageIds.has(pageId)) return 'diptychs';
      if (matriarchTributePageIds.has(pageId)) return 'matriarch-tribute';
      if (patriarchTributePageIds.has(pageId)) return 'patriarch-tribute';
      if (sacramentalLifePageIds.has(pageId)) return 'sacramental-life';
      if (universalPrayerPageIds.has(pageId)) return 'universal-prayer';
      if (catholicGuestWelcomePageIds.has(pageId)) return 'catholic-guest-welcome';
      if (oracionesSpanishIPageIds.has(pageId)) return 'oraciones-spanish-i';
      if (guadalupeDevocionSpanishPageIds.has(pageId)) return 'guadalupe-devocion-spanish';
      if (spiritualBouquetsPageIds.has(pageId)) return 'spiritual-bouquets';
      if (catholicCommittalReceptionPageIds.has(pageId)) return 'catholic-committal-reception';
      if (lifeSketchPageIds.has(pageId)) return 'life-sketch';
      if (multiScriptureConfig[pageId]) return 'multi-scripture';
      if (familyGratitudePageIds.has(pageId)) return 'family-gratitude';
      if (faithfulCoursePageIds.has(pageId)) return 'faithful-course';
      if (keepOrReplaceConfig[pageId]) return 'keep-or-replace-sections';
      if (vigilRosaryPageIds.has(pageId)) return 'vigil-rosary';
      if (inurnmentPageIds.has(pageId)) return 'rite-of-inurnment';
      if (resolutionPageIds.has(pageId)) return 'resolution-of-respect';
      if (serviceOfCommittalPageIds.has(pageId)) return 'service-of-committal';
      if (noteOnlyPageIds.has(pageId)) return 'note-only';
      if (sacredHymnodyPageIds.has(pageId)) return 'sacred-hymnody';
      if (memoryEternalPageIds.has(pageId)) return 'memory-eternal';
      if (makariaMealPageIds.has(pageId)) return 'makaria-meal';
      if (panikhidaSchedulePageIds.has(pageId)) return 'panikhida-schedule';
      if (psalm23PageIds.has(pageId)) return 'psalm-23';
      if (eccl3John14PageIds.has(pageId)) return 'eccl-3-john-14';
      if (twoTimothy4PageIds.has(pageId)) return '2-timothy-4';
      if (psalm91PageIds.has(pageId)) return 'psalm-91';
      if (lordsPrayerPageIds.has(pageId)) return 'lords-prayer';
      if (psalm121PageIds.has(pageId)) return 'psalm-121';
      if (isaiah40Matthew11PageIds.has(pageId)) return 'isaiah-40-matthew-11';
      if (romans8Rev21PageIds.has(pageId)) return 'romans-8-rev-21';
      if (oneCor13TwoCor5PageIds.has(pageId)) return '1-cor-13-2-cor-5';
      if (comfortHopePageIds.has(pageId)) return 'comfort-hope';
      if (prov31BeatitudesPageIds.has(pageId)) return 'prov-31-beatitudes';
      if (psalm62Phil4PageIds.has(pageId)) return 'psalm-62-phil-4';
      if (john11StFrancisPageIds.has(pageId)) return 'john-11-st-francis';
      if (customTextPageIds.has(pageId)) return 'custom-text';
      if (christianWalkPageIds.has(pageId)) return 'christian-walk';
      if (ministryOfMusicPageIds.has(pageId)) return 'ministry-of-music';
      if (repastFellowshipPageIds.has(pageId)) return 'repast-fellowship';
      if (gratitudeExpressionsPageIds.has(pageId)) return 'expressions-of-gratitude';
      if (isCollagePageId(pageId)) return 'collage';
      if (photoTributePageIds.has(pageId)) return 'photo-tributes';
      return 'text-tribute';
    }

    let oosRowCounter = 0;

    function fieldHtmlFor(pageId, title, type) {
      const safeId = pageId.replace(/[^a-z0-9-]/g, '');
      if (type === 'obituary') {
        return `
          <textarea class="review-field-input" data-field="obituary_text" data-page-id="${safeId}" rows="6" placeholder="Write or paste the obituary here..." oninput="checkObituaryLength(this)"></textarea>
          <div class="obit-length-note" id="obitNote-${safeId}" style="font-size:10px; color:#999; margin-top:4px;"></div>
        `;
      }
      if (type === 'order-of-service') {
        return buildOosStyleServicePage(safeId, {
          introText: "Each line below shows the usual wording on the left, and it's fully yours to change — not just the name on the right. For example, if a line doesn't match your service, you can retype it to say whatever part actually applies.",
          mainRows: ['Welcome','Opening Prayer','Opening Prayer','Tribute and Eulogy','Reflections','Words of Comfort','Musical Selection','Recessional'],
          includeHonoraryPallbearers: true,
          acknowledgmentRows: ['Organist / Musician', 'Officiant', 'Church / Venue']
        });
      }
      if (type === 'jw-memorial-service') {
        const part = (label, roleField, nameField, namePlaceholder) => `
          <div style="margin-top:12px; padding-top:10px; border-top:1px solid #2a2a2a;">
            <input type="text" class="review-field-input" data-field="${roleField}" data-page-id="${safeId}" value="${label}" style="font-weight:600;">
            <input type="text" class="review-field-input" data-field="${nameField}" data-page-id="${safeId}" placeholder="${namePlaceholder}" style="margin-top:6px;">
          </div>
        `;
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">Each part below shows the usual wording — feel free to leave it as-is or change it to match your congregation.</p>
          <input type="text" class="review-field-input" data-field="jw_congregation" data-page-id="${safeId}" placeholder="Congregation Name / Location">
          <input type="text" class="review-field-input" data-field="jw_address" data-page-id="${safeId}" placeholder="Street Address, City, State" style="margin-top:6px;">
          <input type="text" class="review-field-input" data-field="jw_service_date" data-page-id="${safeId}" placeholder="Date of Service" style="margin-top:6px;">
          <input type="text" class="review-field-input" data-field="jw_service_time" data-page-id="${safeId}" placeholder="Time" style="margin-top:6px;">
          <input type="text" class="review-field-input" data-field="jw_scripture" data-page-id="${safeId}" value="John 5:28, 29" style="margin-top:6px;">
          ${part("Chairman's Welcome", 'jw_part1_role', 'jw_part1_name', "Chairman's name")}
          ${part('Opening Song', 'jw_part2_role', 'jw_part2_name', 'Song number & title')}
          ${part('Opening Prayer', 'jw_part3_role', 'jw_part3_name', "Elder's name")}
          ${part('Memorial Discourse', 'jw_part4_role', 'jw_part4_name', "Discourse title / theme, and speaker's name")}
          ${part('Concluding Song', 'jw_part5_role', 'jw_part5_name', 'Song number & title')}
          ${part('Concluding Prayer', 'jw_part6_role', 'jw_part6_name', "Speaker's name")}
          <div style="margin-top:12px; padding-top:10px; border-top:1px solid #2a2a2a;">
            <p style="font-size:11px; color:#b8b3a8; margin-bottom:6px;">Optional — leave blank if this service isn't being livestreamed.</p>
            <input type="text" class="review-field-input" data-field="jw_zoom_id" data-page-id="${safeId}" placeholder="Zoom Meeting ID (optional)">
            <input type="text" class="review-field-input" data-field="jw_zoom_passcode" data-page-id="${safeId}" placeholder="Zoom Passcode (optional)" style="margin-top:6px;">
          </div>
        `;
      }
      // Shared builder for the 5 "named order of service" page types (Catholic Mass, Homegoing,
      // Orthodox Burial, Military Honors, First Responder Honors). Each of these pages has the same
      // underlying shape — What/Who rows (What pre-filled & fully editable, Who blank), optional
      // Honored Service Details, Pallbearers, optional Honorary Pallbearers, and an extendable
      // Special Acknowledgments list — just with different wording per tradition. Building this once
      // means a fix here (like the "+ Add another line" on Acknowledgments) applies to all 5 at once.
      function buildOosStyleServicePage(safeId, config) {
        const row = (whatValue) => `
          <div class="oos-row">
            <input type="text" class="review-field-input oos-what" value="${whatValue}">
            <input type="text" class="review-field-input oos-who" placeholder="Name">
          </div>
        `;
        const detailRow = (label, examplePlaceholder) => `
          <div class="oos-row">
            <input type="text" class="review-field-input oos-what" value="${label}">
            <input type="text" class="review-field-input oos-who" placeholder="${examplePlaceholder}">
          </div>
        `;
        const sectionHeader = (label) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:12px 0 4px;">${label}</p>`;
        const introText = config.introText || "Each line below shows the usual wording on the left, and it's fully yours to change — not just the name or detail on the right. For example, if a line doesn't match your service, you can retype it to say whatever part actually applies.";

        const honoredDetailsHtml = config.honoredServiceDetails ? `
          ${sectionHeader('Honored Service Details')}
          <div class="oos-table" id="detailsTable-${safeId}">
            ${config.honoredServiceDetails.map(([label, placeholder]) => detailRow(label, placeholder)).join('')}
          </div>
        ` : '';

        const honoraryPallbearersHtml = config.includeHonoraryPallbearers ? `
          ${sectionHeader('Honorary Pallbearers')}
          <div class="oos-table">
            <div class="oos-row"><input type="text" class="review-field-input" placeholder="Name" data-field="honorary_pallbearer_1" data-page-id="${safeId}"><input type="text" class="review-field-input" placeholder="Name" data-field="honorary_pallbearer_2" data-page-id="${safeId}"></div>
            <div class="oos-row"><input type="text" class="review-field-input" placeholder="Name" data-field="honorary_pallbearer_3" data-page-id="${safeId}"><input type="text" class="review-field-input" placeholder="Name" data-field="honorary_pallbearer_4" data-page-id="${safeId}"></div>
          </div>
        ` : '';

        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">${introText}</p>
          <div class="oos-table" id="oosTable-${safeId}">
            ${config.mainRows.map(r => row(r)).join('')}
          </div>
          <span class="add-row-link" onclick="addOosRow('${safeId}')">+ Add another line</span>
          ${honoredDetailsHtml}
          ${sectionHeader('Pallbearers')}
          <div class="oos-table">
            <div class="oos-row"><input type="text" class="review-field-input" placeholder="Name" data-field="pallbearer_1" data-page-id="${safeId}"><input type="text" class="review-field-input" placeholder="Name" data-field="pallbearer_2" data-page-id="${safeId}"></div>
            <div class="oos-row"><input type="text" class="review-field-input" placeholder="Name" data-field="pallbearer_3" data-page-id="${safeId}"><input type="text" class="review-field-input" placeholder="Name" data-field="pallbearer_4" data-page-id="${safeId}"></div>
            <div class="oos-row"><input type="text" class="review-field-input" placeholder="Name" data-field="pallbearer_5" data-page-id="${safeId}"><input type="text" class="review-field-input" placeholder="Name" data-field="pallbearer_6" data-page-id="${safeId}"></div>
          </div>
          ${honoraryPallbearersHtml}
          ${sectionHeader('Special Acknowledgments')}
          <div class="oos-table" id="ackTable-${safeId}">
            ${config.acknowledgmentRows.map(r => Array.isArray(r) ? detailRow(r[0], r[1]) : row(r)).join('')}
          </div>
          <span class="add-row-link" onclick="addAckRow('${safeId}')">+ Add another line</span>
        `;
      }

      if (type === 'catholic-mass') {
        const sectionHeader = (label) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:12px 0 4px;">${label}</p>`;
        const row = (whatValue) => `
          <div class="oos-row">
            <input type="text" class="review-field-input oos-what" value="${whatValue}">
            <input type="text" class="review-field-input oos-who" placeholder="Name">
          </div>
        `;
        // Catholic Mass has extra sub-sections (Liturgy of the Word, etc.) the shared builder doesn't model,
        // so it keeps its own layout but still uses addAckRow for the now-shared, extendable Acknowledgments list.
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">Each line below shows the usual wording on the left, and it's fully yours to change — not just the name on the right. For example, if \u201cReception of the Body\u201d doesn't apply, you can retype it to say \u201cOpening Prayer\u201d or anything else your service actually includes.</p>
          <div class="oos-table" id="oosTable-${safeId}">
            ${row('Reception of the Body')}
            ${row('Sprinkling with Holy Water')}
            ${row('Placing of the Pall')}
            ${row('Entrance Hymn')}
            ${row('Opening Prayer (Collect)')}
          </div>
          ${sectionHeader('Liturgy of the Word')}
          <div class="oos-table">
            ${row('First Reading')}
            ${row('Responsorial Psalm')}
            ${row('Second Reading')}
            ${row('Gospel Acclamation')}
            ${row('Gospel Reading')}
            ${row('Homily')}
            ${row('Prayers of the Faithful')}
          </div>
          ${sectionHeader('Liturgy of the Eucharist')}
          <div class="oos-table">
            ${row('Presentation of Gifts')}
            ${row('The Eucharistic Prayer')}
            ${row('Communion Hymn')}
          </div>
          ${sectionHeader('Final Commendation & Farewell')}
          <div class="oos-table">
            ${row('Song of Farewell')}
            ${row('Prayer of Commendation')}
            ${row('Recessional Hymn')}
          </div>
          ${sectionHeader('Pallbearers')}
          <div class="oos-table">
            <div class="oos-row"><input type="text" class="review-field-input" placeholder="Name" data-field="pallbearer_1" data-page-id="${safeId}"><input type="text" class="review-field-input" placeholder="Name" data-field="pallbearer_2" data-page-id="${safeId}"></div>
            <div class="oos-row"><input type="text" class="review-field-input" placeholder="Name" data-field="pallbearer_3" data-page-id="${safeId}"><input type="text" class="review-field-input" placeholder="Name" data-field="pallbearer_4" data-page-id="${safeId}"></div>
            <div class="oos-row"><input type="text" class="review-field-input" placeholder="Name" data-field="pallbearer_5" data-page-id="${safeId}"><input type="text" class="review-field-input" placeholder="Name" data-field="pallbearer_6" data-page-id="${safeId}"></div>
          </div>
          ${sectionHeader('Special Acknowledgments')}
          <div class="oos-table" id="ackTable-${safeId}">
            ${row('Organist / Musician')}
            ${row('Celebrant / Priest')}
            ${row('Church / Venue')}
          </div>
          <span class="add-row-link" onclick="addAckRow('${safeId}')">+ Add another line</span>
        `;
      }
      if (type === 'ministry-of-music') {
        // All rows live in ONE table sharing one id, so "+ Add another line" and submission
        // gathering both see every row no matter which section it visually sits under. Section
        // labels are inserted as plain non-input rows inside the same table rather than as
        // separate tables — a page split across several untracked oos-tables would silently lose
        // every row but the first section's when gathered for submission (same class of bug as the
        // earlier Special Acknowledgments miss).
        const sectionRow = (label) => `<div class="oos-row oos-section-label" style="grid-template-columns: 1fr;"><p style="font-size:11px; font-weight:600; color:#d4af37; margin:8px 0 0;">${label}</p></div>`;
        const row = (whatValue, whoPlaceholder) => `
          <div class="oos-row">
            <input type="text" class="review-field-input oos-what" value="${whatValue}">
            <input type="text" class="review-field-input oos-who" placeholder="${whoPlaceholder || 'Name'}">
          </div>
        `;
        // Musical program page — no pallbearers/acknowledgments here, just song selections and the
        // musicians/ministers list. Every line (song title included) is pre-filled but fully editable.
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">Each line below shows a common selection on the left, and it's fully yours to change — song titles, performer names, all of it. If a section doesn't apply to your service, feel free to retype it or leave the name blank.</p>
          <div class="oos-table" id="oosTable-${safeId}">
            ${sectionRow('Prelude & Meditation')}
            ${row('Take My Hand, Precious Lord', 'Organist')}
            ${row('Going Up Yonder', 'Soloist')}
            ${sectionRow('Processional Hymn')}
            ${row('Total Praise (Richard Smallwood)', 'Choir / Group')}
            ${sectionRow('Ministry in Song')}
            ${row('Soon and Very Soon', 'Soloist')}
            ${row("I Won't Complain", 'Soloist / Musician')}
            ${sectionRow('Recessional Praise')}
            ${row('When the Saints Go Marching In', 'Congregation & Musicians')}
            ${sectionRow('Favorite Chorus')}
            ${row('This is the day which the Lord hath made; we will rejoice and be glad in it. — Psalm 118:24', 'leave as-is or change')}
          </div>
          <span class="add-row-link" onclick="addOosRow('${safeId}')">+ Add another line</span>
          <p style="font-size:11px; font-weight:600; color:#d4af37; margin:12px 0 4px;">Church Musicians & Ministers of Sound</p>
          <div class="oos-table">
            <div class="oos-row"><input type="text" class="review-field-input" placeholder="Minister of Music — Full Name" data-field="minister_of_music" data-page-id="${safeId}"><input type="text" class="review-field-input" placeholder="Organist — Full Name" data-field="organist_name" data-page-id="${safeId}"></div>
            <div class="oos-row"><input type="text" class="review-field-input" placeholder="Pianist — Full Name" data-field="pianist_name" data-page-id="${safeId}"><input type="text" class="review-field-input" placeholder="Percussion — Full Name" data-field="percussion_name" data-page-id="${safeId}"></div>
            <div class="oos-row"><input type="text" class="review-field-input" placeholder="Lead Guitar — Full Name" data-field="lead_guitar_name" data-page-id="${safeId}"></div>
          </div>
        `;
      }
      if (type === 'homegoing-celebration') {
        return buildOosStyleServicePage(safeId, {
          introText: "Each line below shows the usual wording on the left, and it's fully yours to change — not just the name on the right. For example, if \u201cReception of the Body\u201d doesn't apply, you can retype it to say \u201cOpening Prayer\u201d or anything else your service actually includes.",
          mainRows: ['Organ Prelude','Processional','Opening Hymn','Old Testament','New Testament','Prayer of Comfort','Musical Selection','Church Resolutions & Acknowledgments','Reading of Condolences','Obituary Reading','Eulogy & Tributes','Sermon / Message of Hope','Closing Prayer & Benediction','Recessional'],
          includeHonoraryPallbearers: true,
          acknowledgmentRows: ['Organist / Musician', 'Officiant', 'Church / Venue']
        });
      }
      if (type === 'orthodox-burial') {
        return buildOosStyleServicePage(safeId, {
          introText: "Each line below shows the usual wording on the left, and it's fully yours to change — not just the name on the right. For example, if \u201cReception of the Body\u201d doesn't apply, you can retype it to say \u201cOpening Prayer\u201d or anything else your service actually includes.",
          mainRows: ['Trisagion Service','Processional Hymn','Troparia & Kathisma','Epistle','Gospel Reading','Homily','Litany for the Departed','Prayer of Absolution','The Last Kiss (Final Veneration)','Memory Eternal ("Vechnaya Pamyat")','Eulogy & Tributes','Recessional'],
          includeHonoraryPallbearers: true,
          acknowledgmentRows: ['Choir Director', 'Celebrant / Priest', 'Church / Venue']
        });
      }
      if (type === 'military-honors') {
        return buildOosStyleServicePage(safeId, {
          mainRows: ['Presentation of Colors','Three-Volley Rifle Salute','Sounding of Taps','Ceremonial Folding of the Flag','Presentation of the National Colors','Final Salute & Dismissal'],
          honoredServiceDetails: [['Rank & Name','[Rank] [Full Name]'],['Branch of Service','e.g. United States Army'],['Years of Service','[Start Year] \u2013 [End Year]'],['Unit / Regiment','e.g. 101st Airborne Division']],
          includeHonoraryPallbearers: true,
          acknowledgmentRows: [['Honor Guard Detail','Military Unit / Installation Name'],['Bugler','Musician Name / Military Detail'],['Location / Cemetery','National Cemetery Name']]
        });
      }
      if (type === 'first-responder-honors') {
        return buildOosStyleServicePage(safeId, {
          mainRows: ['Procession & Escort','Presentation of Colors','Bell / Badge Ceremony','The Last Alarm / End of Watch','Recessional'],
          honoredServiceDetails: [['Rank & Name','[Rank] [Full Name]'],['Agency / Department','e.g. City Fire Dept'],['Years of Service','[Start Year] \u2013 [End Year]'],['Station / Precinct / Unit','e.g. Station 87 / 77th Precinct']],
          includeHonoraryPallbearers: true,
          acknowledgmentRows: [['Honor Guard Detail','Honor Guard Unit'],['Bagpiper / Musician','Musician Name / Pipe Band Name'],['Location / Cemetery','Cemetery Name']]
        });
      }
      if (type === 'family-lineage') {
        const sectionHeader = (label, sublabel) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 2px;">${label}</p>${sublabel ? `<p style="font-size:10px; color:#999; margin-bottom:6px; font-style:italic;">${sublabel}</p>` : ''}`;
        return `
          ${sectionHeader('Generation I: Our Ancestors', 'Grandparents / Matriarch & Patriarch')}
          <input type="text" class="review-field-input" data-field="gen1_person1" data-page-id="${safeId}" placeholder="Full name and years (e.g. Arthur Eugene Thomas, 1918–1994)">
          <input type="text" class="review-field-input" data-field="gen1_person2" data-page-id="${safeId}" placeholder="Married to — full name and years" style="margin-top:6px;">

          ${sectionHeader('Generation II: The Family', 'Children of the Generation I couple — include your loved one\\u2019s name in this list')}
          <div id="gen2List-${safeId}">
            <input type="text" class="review-field-input name-list-row" placeholder="Name (and spouse, if married)">
          </div>
          <span class="add-row-link" onclick="addNameRow('gen2List-${safeId}', 'Name (and spouse, if married)')">+ Add another name</span>

          ${sectionHeader('Generation III: The Next Generation')}
          <div id="gen3List-${safeId}">
            <input type="text" class="review-field-input name-list-row" placeholder="Name (and spouse, if married)">
          </div>
          <span class="add-row-link" onclick="addNameRow('gen3List-${safeId}', 'Name (and spouse, if married)')">+ Add another name</span>

          ${sectionHeader('Generation IV: Grandchildren & Great-Grandchildren')}
          <textarea class="review-field-input" data-field="grandchildren_names" data-page-id="${safeId}" rows="2" placeholder="Grandchildren — names separated by commas"></textarea>
          <textarea class="review-field-input" data-field="great_grandchildren_names" data-page-id="${safeId}" rows="2" placeholder="Great-Grandchildren — names separated by commas (leave blank if none)" style="margin-top:6px;"></textarea>
        `;
      }
      if (type === 'generational-legacy') {
        const sectionHeader = (label, sublabel) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 2px;">${label}</p>${sublabel ? `<p style="font-size:10px; color:#999; margin-bottom:6px; font-style:italic;">${sublabel}</p>` : ''}`;
        return `
          ${sectionHeader('Photo')}
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:6px;">This page uses a family/group photo. Please email it to <strong>photos@notedandcharmed.com</strong> and let us know below which photo it is (e.g. "the grandkids photo" or the file name), so we can match it to this page.</p>
          <input type="text" class="review-field-input" data-field="gl_photo_id_note" data-page-id="${safeId}" placeholder="Which photo is this? (e.g. file name or short description)">

          ${sectionHeader('Dedication')}
          <input type="text" class="review-field-input" data-field="gl_dedication_name" data-page-id="${safeId}" placeholder="To Our Beloved... (e.g. Grandma Ruth, Nana, Pop-Pop)" style="margin-top:6px;">

          ${sectionHeader('Scripture')}
          <input type="text" class="review-field-input" data-field="gl_scripture_ref" data-page-id="${safeId}" value="Proverbs 17:6" style="margin-top:6px;">
          <select class="review-field-input" data-field="gl_scripture_version" data-page-id="${safeId}" style="margin-top:6px;">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
          <textarea class="review-field-input" data-field="gl_scripture_text" data-page-id="${safeId}" rows="3" placeholder="Type or paste the exact verse wording here, in the version you chose above" style="margin-top:6px;">Children's children are the crown of old men; and the glory of children are their fathers.</textarea>

          ${sectionHeader('Tribute')}
          <textarea class="review-field-input" data-field="gl_tribute_text" data-page-id="${safeId}" rows="6">You taught us the meaning of unconditional love, the strength of faith, and the comfort of family. Your home was our sanctuary, your laughter our joy, and your prayers our shield. We promise to carry your legacy forward, to walk in the wisdom you planted in our hearts, and to love one another just as you loved us.

Rest peacefully in the arms of the Lord.</textarea>

          ${sectionHeader('The Next Generations')}
          <p style="font-size:10px; color:#999; margin-bottom:6px;">Grandchildren</p>
          <div id="glGrandkidsList-${safeId}">
            <input type="text" class="review-field-input name-list-row" placeholder="Full name">
          </div>
          <span class="add-row-link" onclick="addNameRow('glGrandkidsList-${safeId}', 'Full name')">+ Add another name</span>

          <p style="font-size:10px; color:#999; margin:10px 0 6px;">Great-Grandchildren</p>
          <div id="glGreatGrandkidsList-${safeId}">
            <input type="text" class="review-field-input name-list-row" placeholder="Full name">
          </div>
          <span class="add-row-link" onclick="addNameRow('glGreatGrandkidsList-${safeId}', 'Full name')">+ Add another name</span>

          <p style="font-size:10px; color:#999; margin:10px 0 6px;">Great-Great-Grandchildren</p>
          <div id="glGreatGreatGrandkidsList-${safeId}">
            <input type="text" class="review-field-input name-list-row" placeholder="Full name">
          </div>
          <span class="add-row-link" onclick="addNameRow('glGreatGreatGrandkidsList-${safeId}', 'Full name')">+ Add another name</span>
        `;
      }
      if (type === 'life-in-church') {
        const sectionHeader = (label) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 2px;">${label}</p>`;
        const field = (fieldName, placeholder, value) => `<input type="text" class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" placeholder="${placeholder}"${value ? ` value="${value}"` : ''} style="margin-top:6px;">`;
        const scriptureBlock = (refField, versionField, textField, refValue, textValue) => `
          <input type="text" class="review-field-input" data-field="${refField}" data-page-id="${safeId}" value="${refValue}" style="margin-top:6px;">
          <select class="review-field-input" data-field="${versionField}" data-page-id="${safeId}" style="margin-top:6px;">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
          <textarea class="review-field-input" data-field="${textField}" data-page-id="${safeId}" rows="2" placeholder="Type or paste the exact verse wording here, in the version you chose above" style="margin-top:6px;">${textValue}</textarea>
        `;
        const nameListSection = (label, listId, placeholder) => `
          ${sectionHeader(label)}
          <div id="${listId}-${safeId}">
            <input type="text" class="review-field-input name-list-row" placeholder="${placeholder}">
          </div>
          <span class="add-row-link" onclick="addNameRow('${listId}-${safeId}', '${placeholder}')">+ Add another</span>
        `;
        return `
          ${sectionHeader('Opening Scripture')}
          <p style="font-size:10px; color:#999; margin-bottom:2px; font-style:italic;">Feel free to keep this reference or choose a different verse.</p>
          ${scriptureBlock('lic_scripture1_ref', 'lic_scripture1_version', 'lic_scripture1_text', '2 Timothy 4:7', "I have fought the good fight, I have finished the race, I have kept the faith.")}

          ${sectionHeader('Sacramental Milestones')}
          ${field('lic_baptismal_name', 'Christian / Baptismal Name (e.g., Spyridon / Photini)')}
          ${field('lic_patron_saint', 'Patron Saint (e.g., Saint Name)')}
          ${field('lic_name_day', 'Name Day (Month, Day)')}
          ${field('lic_baptism_date', 'Holy Baptism & Chrismation — Date')}
          ${field('lic_baptism_parish', 'Holy Baptism & Chrismation — Parish Name, City, State')}
          ${nameListSection('Sponsors / Godparents (Nounoi)', 'licGodparentsList', 'Godparent full name')}
          ${field('lic_matrimony_date', 'Holy Matrimony — Date')}
          ${field('lic_spouse_name', "Holy Matrimony — Spouse's Full Name")}
          ${nameListSection('Crowner / Wedding Sponsor (Koumbaros)', 'licKoumbarosList', 'Sponsor full name')}

          ${sectionHeader('Parish Dedication & Service')}
          ${field('lic_home_parish', 'Home Parish — Name, City, State')}
          ${field('lic_fellowship_years', 'Years of Active Fellowship (e.g. 1985–2024, 39 Years)')}
          ${nameListSection('Parish Ministries & Societies', 'licMinistriesList', 'Ministry or society (e.g. Philoptochos Society)')}
          ${field('lic_sanctuary_service', 'Sanctuary & Community Service (e.g. Choir Member)')}
          ${nameListSection('Honors & Archdiocesan Recognitions', 'licHonorsList', 'Honor or recognition (e.g. Medal of St. Paul)')}

          ${sectionHeader('Heritage & Sacred Memories')}
          ${field('lic_ancestral_homeland', 'Ancestral Homeland & Village (Village/City of Origin, Country)')}
          ${field('lic_immigration_year', 'Immigration & New Beginnings — Year')}
          ${field('lic_port_of_entry', 'Immigration & New Beginnings — Port of Entry (City)')}
          ${field('lic_family_icon', 'Family Icon & Home Chapel (Icon of Patron Saint / Theotokos)')}
          <textarea class="review-field-input" data-field="lic_life_of_prayer" data-page-id="${safeId}" rows="3" placeholder="A Life of Prayer — a 2-3 line note on their devotion, fasting, hospitality, and love" style="margin-top:6px;"></textarea>

          ${sectionHeader('Closing Scripture')}
          <p style="font-size:10px; color:#999; margin-bottom:2px; font-style:italic;">Feel free to keep this reference or choose a different verse.</p>
          ${scriptureBlock('lic_scripture2_ref', 'lic_scripture2_version', 'lic_scripture2_text', 'Joshua 24:15', "As for me and my house, we will serve the Lord.")}
        `;
      }
      if (type === 'diptychs') {
        const sectionHeader = (label, sublabel) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 2px;">${label}</p>${sublabel ? `<p style="font-size:10px; color:#999; margin-bottom:6px; font-style:italic;">${sublabel}</p>` : ''}`;
        const field = (fieldName, placeholder) => `<input type="text" class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" placeholder="${placeholder}" style="margin-top:6px;">`;
        const namesArea = (fieldName, placeholder, rows) => `<textarea class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" rows="${rows || 2}" placeholder="${placeholder}" style="margin-top:6px;"></textarea>`;
        return `
          <p style="font-size:10px; color:#999; margin-bottom:10px; font-style:italic;">Opening line is fixed and printed as-is: "Remember, O Lord, those who have fallen asleep before us in the hope of resurrection."</p>

          ${sectionHeader('The Memorial Diptychs — For the Repose of the Departed', 'Names offered for commemoration in the Divine Liturgy')}
          ${field('dip_parents', "Parents — Father's and Mother's Christian Names")}
          ${namesArea('dip_grandparents', 'Grandparents — names, separated by commas')}
          ${namesArea('dip_siblings_relatives', 'Siblings & Relatives — names, separated by commas')}
          ${namesArea('dip_spiritual_fathers', 'Spiritual Fathers — names of departed priests / monastics, separated by commas')}

          ${sectionHeader('For the Health & Salvation of the Living')}
          ${namesArea('dip_children_living', 'Children — names, separated by commas')}
          ${namesArea('dip_grandchildren_living', 'Grandchildren — names, separated by commas')}
          ${namesArea('dip_godchildren_kin', 'Godchildren & Extended Kin — names, separated by commas')}

          ${sectionHeader('Expressions of Family Gratitude')}
          ${field('dip_presiding_clergy', 'Presiding Clergy — Priest Name')}
          ${namesArea('dip_deacons_subdeacons', 'Assisting Deacons & Subdeacons — names, separated by commas', 3)}
          ${field('dip_cantors_choir', 'Cantors & Choir (Psaltis) — Director Name & Parish Choir')}
          ${namesArea('dip_caregivers', 'Compassionate Caregivers — Hospice / Medical Center Staff Names')}

          ${sectionHeader('Memorial Stewardship & Tributes')}
          ${field('dip_in_memory_of', 'In lieu of flowers, donations in memory of...')}
          <p style="font-size:10px; color:#999; margin-bottom:2px;">Parish ministries to direct donations to (e.g. Iconography Project, Building Fund, Ladies Philoptochos Society)</p>
          ${namesArea('dip_ministries', 'Ministries / funds, separated by commas or one per line', 3)}
          ${field('dip_outside_charity', 'Optional outside charity or hospice foundation')}
        `;
      }
      if (type === 'matriarch-tribute') {
        const sectionHeader = (label, sublabel) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 2px;">${label}</p>${sublabel ? `<p style="font-size:10px; color:#999; margin-bottom:6px; font-style:italic;">${sublabel}</p>` : ''}`;
        const scriptureBlock = (refField, versionField, textField, refValue, textValue) => `
          <input type="text" class="review-field-input" data-field="${refField}" data-page-id="${safeId}" value="${refValue}" style="margin-top:6px;">
          <select class="review-field-input" data-field="${versionField}" data-page-id="${safeId}" style="margin-top:6px;">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
          <textarea class="review-field-input" data-field="${textField}" data-page-id="${safeId}" rows="2" placeholder="Type or paste the exact verse wording here, in the version you chose above" style="margin-top:6px;">${textValue}</textarea>
        `;
        return `
          <p style="font-size:10px; color:#999; margin-bottom:10px; font-style:italic;">Works for any faith tradition, secular families, or anything in between — feel free to change or remove any scripture line, or leave a section blank if it doesn't fit your family.</p>

          <input type="text" class="review-field-input" data-field="mt_honoree_name" data-page-id="${safeId}" placeholder="In Loving Memory of... (Full Name of Honoree)">

          ${sectionHeader('Opening Scripture')}
          <p style="font-size:10px; color:#999; margin-bottom:2px; font-style:italic;">Feel free to keep this reference or choose a different verse — or leave blank if not wanted.</p>
          ${scriptureBlock('mt_scripture1_ref', 'mt_scripture1_version', 'mt_scripture1_text', 'Proverbs 31:26', "She opens her mouth with wisdom, and the teaching of kindness is on her tongue.")}

          ${sectionHeader('The Heart of the Home', 'A Tribute From Her Children')}
          <textarea class="review-field-input" data-field="mt_tribute_text" data-page-id="${safeId}" rows="8">There was always room at our mother's table. No matter who knocked on her door, no matter the hour, a place was set, coffee was poured, and comfort was given. She taught us that hospitality is not an occasion, but a way of living.

Through every season—lean years and abundance alike—her hands worked quietly. She mended our wounds, prayed over our worries, and anchored our family in faith. Her kitchen was our sanctuary, where recipes were passed down not by measurement, but by instinct, memory, and love.</textarea>

          ${sectionHeader('Traditions We Carry Forward')}
          <textarea class="review-field-input" data-field="mt_cherished_traditions" data-page-id="${safeId}" rows="2" placeholder="Her Cherished Traditions (e.g. Sunday Dinners, Holiday Baking, Family Prayers)"></textarea>
          <textarea class="review-field-input" data-field="mt_words_lived_by" data-page-id="${safeId}" rows="2" placeholder="Words She Always Lived By (favorite family saying or piece of advice)" style="margin-top:6px;"></textarea>
          <textarea class="review-field-input" data-field="mt_greatest_joy" data-page-id="${safeId}" rows="2" placeholder="Her Greatest Joy in Life (e.g. Rocking her grandchildren, working in her garden)" style="margin-top:6px;"></textarea>

          ${sectionHeader("A Daughter/Son's Promise")}
          <p style="font-size:10px; color:#999; margin-bottom:6px;">Check whichever apply — signers can be any combination of daughters and sons.</p>
          <div style="display:flex; flex-direction:column; gap:6px; font-size:11px; margin-bottom:8px;">
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="checkbox" data-field="mt_signed_by_daughter" data-page-id="${safeId}"> Daughter</label>
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="checkbox" data-field="mt_signed_by_daughters" data-page-id="${safeId}"> Daughters (more than one)</label>
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="checkbox" data-field="mt_signed_by_son" data-page-id="${safeId}"> Son</label>
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="checkbox" data-field="mt_signed_by_sons" data-page-id="${safeId}"> Sons (more than one)</label>
          </div>
          <textarea class="review-field-input" data-field="mt_promise_text" data-page-id="${safeId}" rows="6">Mom, we will keep your table full. We will teach our children the songs you sang, the prayers you taught us at your knee, and the grace with which you carried yourself. Your labor is finished, your rest is earned, and your love remains our compass.

With Endless Love and Devotion,</textarea>

          ${sectionHeader('Closing Scripture')}
          <p style="font-size:10px; color:#999; margin-bottom:2px; font-style:italic;">Feel free to keep this reference or choose a different verse — or leave blank if not wanted.</p>
          ${scriptureBlock('mt_scripture2_ref', 'mt_scripture2_version', 'mt_scripture2_text', 'Proverbs 31:31', "Honor her for all that her hands have done, and let her works bring her praise at the city gates.")}
        `;
      }
      if (type === 'patriarch-tribute') {
        const sectionHeader = (label, sublabel) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 2px;">${label}</p>${sublabel ? `<p style="font-size:10px; color:#999; margin-bottom:6px; font-style:italic;">${sublabel}</p>` : ''}`;
        const scriptureBlock = (refField, versionField, textField, refValue, textValue) => `
          <input type="text" class="review-field-input" data-field="${refField}" data-page-id="${safeId}" value="${refValue}" style="margin-top:6px;">
          <select class="review-field-input" data-field="${versionField}" data-page-id="${safeId}" style="margin-top:6px;">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
          <textarea class="review-field-input" data-field="${textField}" data-page-id="${safeId}" rows="2" placeholder="Type or paste the exact verse wording here, in the version you chose above" style="margin-top:6px;">${textValue}</textarea>
        `;
        return `
          <p style="font-size:10px; color:#999; margin-bottom:10px; font-style:italic;">Works for any faith tradition, secular families, or anything in between — feel free to change or remove any scripture line, or leave a section blank if it doesn't fit your family.</p>

          <input type="text" class="review-field-input" data-field="pt_honoree_name" data-page-id="${safeId}" placeholder="In Loving Memory of... (Full Name of Honoree)">

          ${sectionHeader('Opening Scripture')}
          <p style="font-size:10px; color:#999; margin-bottom:2px; font-style:italic;">Feel free to keep this reference or choose a different verse — or leave blank if not wanted.</p>
          ${scriptureBlock('pt_scripture1_ref', 'pt_scripture1_version', 'pt_scripture1_text', 'Proverbs 20:7', "A righteous man who walks in his integrity—blessed are his children after him.")}

          ${sectionHeader('Personal Motto')}
          <textarea class="review-field-input" data-field="pt_personal_motto" data-page-id="${safeId}" rows="2">I have learned that quiet strength speaks louder than many words.</textarea>

          ${sectionHeader('The Lessons of a Lifetime', 'A Tribute From His Children')}
          <textarea class="review-field-input" data-field="pt_tribute_text" data-page-id="${safeId}" rows="8">Our father's life was defined not by what he said, but by what he built. His hands were weathered from honest labor, his word was as binding as an iron vow, and his presence gave our home a foundation that never wavered in a storm.

He never sought the spotlight. He woke before the sun, worked without complaint, and took his greatest pride in seeing his children stand tall, independent, and honorable. He taught us that respect is earned, character is kept in the dark, and family comes first.</textarea>

          ${sectionHeader('Principles Passed Down')}
          <input type="text" class="review-field-input" data-field="pt_trade_craft" data-page-id="${safeId}" placeholder="His Trade & Craft (e.g. Master Carpenter, Railroader, Veteran, Farmer)" style="margin-top:6px;">
          <textarea class="review-field-input" data-field="pt_standard_of_honor" data-page-id="${safeId}" rows="2" style="margin-top:6px;">A man's word is his bond.</textarea>
          <input type="text" class="review-field-input" data-field="pt_favorite_pastime" data-page-id="${safeId}" placeholder="His Favorite Pastime (e.g. Fishing at dawn, woodcraft, working in the shop)" style="margin-top:6px;">

          ${sectionHeader('Our Last Salute to Dad')}
          <p style="font-size:10px; color:#999; margin-bottom:6px;">Check whichever apply — signers can be any combination of sons and daughters.</p>
          <div style="display:flex; flex-direction:column; gap:6px; font-size:11px; margin-bottom:8px;">
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="checkbox" data-field="pt_signed_by_daughter" data-page-id="${safeId}"> Daughter</label>
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="checkbox" data-field="pt_signed_by_daughters" data-page-id="${safeId}"> Daughters (more than one)</label>
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="checkbox" data-field="pt_signed_by_son" data-page-id="${safeId}"> Son</label>
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="checkbox" data-field="pt_signed_by_sons" data-page-id="${safeId}"> Sons (more than one)</label>
          </div>
          <textarea class="review-field-input" data-field="pt_promise_text" data-page-id="${safeId}" rows="6">Dad, thank you for the sacrifices you never spoke of, the firm hand that guided us, and the steady example you set every day of your life. The tools you handed down are in good hands. We will carry your name with pride and never forget the path you cleared.

With Deep Respect and Gratitude,</textarea>
        `;
      }
      if (type === 'sacramental-life') {
        const sectionHeader = (label, sublabel) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 2px;">${label}</p>${sublabel ? `<p style="font-size:10px; color:#999; margin-bottom:6px; font-style:italic;">${sublabel}</p>` : ''}`;
        const field = (fieldName, placeholder) => `<input type="text" class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" placeholder="${placeholder}" style="margin-top:6px;">`;
        const scriptureBlock = (refField, versionField, textField, refValue, textValue) => `
          <input type="text" class="review-field-input" data-field="${refField}" data-page-id="${safeId}" value="${refValue}" style="margin-top:6px;">
          <select class="review-field-input" data-field="${versionField}" data-page-id="${safeId}" style="margin-top:6px;">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
          <textarea class="review-field-input" data-field="${textField}" data-page-id="${safeId}" rows="2" placeholder="Type or paste the exact verse wording here, in the version you chose above" style="margin-top:6px;">${textValue}</textarea>
        `;
        return `
          ${sectionHeader('Opening Scripture')}
          <p style="font-size:10px; color:#999; margin-bottom:2px; font-style:italic;">Feel free to keep this reference or choose a different verse.</p>
          ${scriptureBlock('sl_scripture1_ref', 'sl_scripture1_version', 'sl_scripture1_text', '2 Timothy 4:7', "I have fought the good fight, I have finished the race, I have kept the faith.")}

          ${sectionHeader('Holy Baptism')}
          ${field('sl_baptism_date', 'Date of Baptism')}
          ${field('sl_baptism_parish', 'Parish Name, City, State')}
          ${field('sl_godfather_name', "Godfather's Name")}
          ${field('sl_godmother_name', "Godmother's Name")}

          ${sectionHeader('First Holy Communion')}
          ${field('sl_communion_date', 'Date or Year')}
          ${field('sl_communion_parish', 'Parish Name, City, State')}
          <p style="font-size:10px; color:#999; margin:8px 0 2px; font-style:italic;">Feel free to keep this reference or choose a different verse.</p>
          ${scriptureBlock('sl_scripture2_ref', 'sl_scripture2_version', 'sl_scripture2_text', 'John 6:35', "I am the bread of life.")}

          ${sectionHeader('Sacrament of Confirmation')}
          ${field('sl_confirmation_date', 'Date of Confirmation')}
          ${field('sl_confirmation_parish', 'Parish Name, City, State')}
          ${field('sl_confirmation_name', 'Confirmation Name (Saint Name)')}
          ${field('sl_confirmation_sponsor', 'Sponsor Name')}

          ${sectionHeader('Holy Matrimony')}
          ${field('sl_marriage_date', 'Date of Marriage')}
          ${field('sl_marriage_parish', 'Parish / Church Name, City, State')}
          ${field('sl_spouse_name', "Spouse's Full Name")}
          ${field('sl_years_married', 'Number of Years of Sacred Covenant')}

          ${sectionHeader('Parish Service & Devotion')}
          <textarea class="review-field-input" data-field="sl_parish_service" data-page-id="${safeId}" rows="3" placeholder="Home Parish and years as a parishioner, memberships (e.g. Knights of Columbus Council #, Altar Society, Choir), and any roles (e.g. Lector, Extraordinary Minister of Holy Communion)"></textarea>

          ${sectionHeader('Anointing of the Sick')}
          <p style="font-size:10px; color:#999; margin-bottom:2px; font-style:italic;">"Fortified by the Rites of Holy Mother Church" is fixed and printed as-is.</p>
          ${field('sl_last_rites_date', 'Date of Last Rites / Final Blessing')}

          <p style="font-size:10px; color:#999; margin-top:14px; font-style:italic;">Closing line is fixed and printed as-is: "May perpetual light shine upon them."</p>
        `;
      }
      if (type === 'universal-prayer') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">This page's wording is fixed and printed as shown — the Celebrant's opening and closing, all five intercessions, and the responses. The only thing we need from you is the first name to insert wherever the page calls for it.</p>
          <input type="text" class="review-field-input" data-field="up_first_name" data-page-id="${safeId}" placeholder="First Name (to insert into the intercessions)">
        `;
      }
      if (type === 'catholic-guest-welcome') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">This page's guidance on postures and Communion is fixed and printed as shown. The only thing we need from you is the full name for the welcome paragraph.</p>
          <input type="text" class="review-field-input" data-field="cgw_full_name" data-page-id="${safeId}" placeholder="Full Name (for 'The family of ___ extends a sincere welcome...')">
        `;
      }
      if (type === 'oraciones-spanish-i') {
        const sectionHeader = (label, sublabel) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 2px;">${label}</p>${sublabel ? `<p style="font-size:10px; color:#999; margin-bottom:6px; font-style:italic;">${sublabel}</p>` : ''}`;
        const field = (fieldName, placeholder) => `<input type="text" class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" placeholder="${placeholder}" style="margin-top:6px;">`;
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The devotional text on this page — Our Lady's words to St. Juan Diego and the commendation prayer — is fixed and printed as shown. The only thing we need from you is the name, plus the Novena's date and location details.</p>

          <input type="text" class="review-field-input" data-field="os1_name" data-page-id="${safeId}" placeholder="Name (used throughout the page's fixed text)">

          ${sectionHeader('The Nine-Day Mourning Novena')}
          ${field('os1_start_date', 'Start Date (Day of Week, Month Day, Year)')}
          ${field('os1_gathering_time', 'Gathering Time (e.g. 7:00 PM)')}
          ${field('os1_location', 'Location (Family Home / Parish Hall / Chapel)')}
          ${field('os1_address', 'Address (Street, City, State, Zip)')}

          <p style="font-size:10px; color:#999; margin-top:14px; font-style:italic;">Closing "Eternal Rest" prayer is fixed and printed as-is.</p>
        `;
      }
      if (type === 'guadalupe-devocion-spanish') {
        const sectionHeader = (label, sublabel) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 2px;">${label}</p>${sublabel ? `<p style="font-size:10px; color:#999; margin-bottom:6px; font-style:italic;">${sublabel}</p>` : ''}`;
        const field = (fieldName, placeholder) => `<input type="text" class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" placeholder="${placeholder}" style="margin-top:6px;">`;
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">El texto devocional de esta página — las palabras de Nuestra Señora a San Juan Diego y la oración de encomendación — está fijo y se imprime tal como se muestra. Lo único que necesitamos de usted es el nombre, además de la fecha y el lugar del Novenario. / This page's devotional text — Our Lady's words to St. Juan Diego and the commendation prayer — is fixed and printed as shown. The only thing we need from you is the name, plus the Novena's date and location details.</p>

          <input type="text" class="review-field-input" data-field="gds_name" data-page-id="${safeId}" placeholder="Nombre (usado en todo el texto fijo de la página) / Name (used throughout the page's fixed text)">

          ${sectionHeader('El Novenario de Duelo / The Nine-Day Mourning Novena')}
          ${field('gds_start_date', 'Fecha de Inicio (Día de la Semana, Fecha Completa) / Start Date')}
          ${field('gds_gathering_time', 'Hora de Reunión (ej., 7:00 PM) / Gathering Time')}
          ${field('gds_location', 'Lugar (Hogar de la Familia / Parroquia / Capilla) / Location')}
          ${field('gds_address', 'Dirección (Calle, Ciudad, Estado, Código Postal) / Address')}

          <p style="font-size:10px; color:#999; margin-top:14px; font-style:italic;">La oración final "Descanso Eterno" está fija y se imprime tal como se muestra. / Closing "Eternal Rest" prayer is fixed and printed as-is.</p>
        `;
      }
      if (type === 'spiritual-bouquets') {
        const sectionHeader = (label, sublabel) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 2px;">${label}</p>${sublabel ? `<p style="font-size:10px; color:#999; margin-bottom:6px; font-style:italic;">${sublabel}</p>` : ''}`;
        const field = (fieldName, placeholder) => `<input type="text" class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" placeholder="${placeholder}" style="margin-top:6px;">`;
        return `
          ${sectionHeader('The Holy Sacrifice of the Mass')}
          <textarea class="review-field-input" data-field="sb_mass_intro_text" data-page-id="${safeId}" rows="3">In Catholic tradition, the greatest gift we can offer for the repose of a soul is the Holy Sacrifice of the Mass.</textarea>

          ${sectionHeader('Parish Contact for Memorial Masses')}
          ${field('sb_parish_name', 'Home Parish Name')}
          ${field('sb_parish_address', 'Parish Street Address')}
          ${field('sb_parish_city_state_zip', 'Parish City, State, Zip')}
          ${field('sb_parish_phone_website', 'Parish Phone Number or Website')}

          ${sectionHeader('Charitable Remembrances')}
          ${field('sb_first_name', "First Name (for \"donations to ministries close to ___'s heart\")")}
          <p style="font-size:10px; color:#999; margin-bottom:2px;">Each line below is one organization — name and mailing address/URL together, e.g. "St. Vincent de Paul Society — stvincentdepaul.org"</p>
          <div id="sbCharitiesList-${safeId}">
            <input type="text" class="review-field-input name-list-row" placeholder="Organization — Mailing Address or Web URL">
            <input type="text" class="review-field-input name-list-row" placeholder="Organization — Mailing Address or Web URL" style="margin-top:6px;">
          </div>
          <span class="add-row-link" onclick="addNameRow('sbCharitiesList-${safeId}', 'Organization — Mailing Address or Web URL')">+ Add another organization</span>

          ${sectionHeader('With Sincere Gratitude')}
          ${field('sb_priest_name', 'Priest Name (Rev. ___)')}
          ${field('sb_church_name', 'Church / Parish Community Name')}
          <textarea class="review-field-input" data-field="sb_gratitude_text" data-page-id="${safeId}" rows="4" style="margin-top:6px;">The family wishes to express their deepest appreciation to Rev. [Priest Name], the parish community of [Church Name], and the caregivers who offered spiritual and physical comfort during [First Name]'s final days.</textarea>
        `;
      }
      if (type === 'catholic-committal-reception') {
        const sectionHeader = (label) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 2px;">${label}</p>`;
        const field = (fieldName, placeholder) => `<input type="text" class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" placeholder="${placeholder}" style="margin-top:6px;">`;
        return `
          ${sectionHeader('The Rite of Committal')}
          <p style="font-size:10px; color:#999; margin-bottom:6px;">Immediately following the Mass</p>
          ${field('ccr_cemetery_name', 'Cemetery or Mausoleum Name')}
          ${field('ccr_cemetery_address', 'Address / Section / Plot Details')}
          ${field('ccr_cemetery_city_state', 'City, State')}
          <textarea class="review-field-input" data-field="ccr_committal_quote" data-page-id="${safeId}" rows="2" style="margin-top:6px;">For to Your faithful people, O Lord, life is changed, not ended.</textarea>

          ${sectionHeader('Reception & Repast')}
          <textarea class="review-field-input" data-field="ccr_reception_intro" data-page-id="${safeId}" rows="2">The family invites you to join them for a meal and sharing of memories following the burial service.</textarea>
          ${field('ccr_reception_venue', 'Venue Name (Parish Hall / Restaurant / Family Home)')}
          ${field('ccr_reception_address', 'Address')}
          ${field('ccr_reception_city_state', 'City, State')}

          ${sectionHeader('Acknowledgment')}
          <textarea class="review-field-input" data-field="ccr_acknowledgment_text" data-page-id="${safeId}" rows="3">The family wishes to express their sincere gratitude for your prayers, love, and presence during this time.</textarea>
        `;
      }
      if (type === 'sacred-hymnody') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The scripture and prayer on this page are fixed and printed as shown. The only thing we need from you is one choice below.</p>
          <p style="font-size:11px; font-weight:600; color:#d4af37; margin-bottom:6px;">In Paradisum refers to "our brother/sister" — which applies?</p>
          <div style="display:flex; flex-direction:column; gap:6px; font-size:11px;">
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="radio" name="shBrotherSister-${safeId}" value="brother" data-field="sh_brother_sister" data-page-id="${safeId}"> Brother</label>
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="radio" name="shBrotherSister-${safeId}" value="sister" data-field="sh_brother_sister" data-page-id="${safeId}"> Sister</label>
          </div>
        `;
      }
      if (type === 'memory-eternal') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The Trisagion Prayers, Prayer for the Repose, and Memory Eternal wording are fixed and printed as shown. The only thing we need from you is the name to insert wherever the page calls for it.</p>
          <input type="text" class="review-field-input" data-field="me_name" data-page-id="${safeId}" placeholder="Name (to insert into the Prayer for the Repose and Memory Eternal)">
        `;
      }
      if (type === 'makaria-meal') {
        const sectionHeader = (label, sublabel) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 2px;">${label}</p>${sublabel ? `<p style="font-size:10px; color:#999; margin-bottom:6px; font-style:italic;">${sublabel}</p>` : ''}`;
        const field = (fieldName, placeholder) => `<input type="text" class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" placeholder="${placeholder}" style="margin-top:6px;">`;
        const keepOrReplace = (radioName, keepField, customField, fixedText, customPlaceholder) => `
          <div style="display:flex; flex-direction:column; gap:6px; font-size:11px; margin:6px 0;">
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="radio" name="${radioName}-${safeId}" value="keep" data-field="${keepField}" data-page-id="${safeId}" checked> Use this wording</label>
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="radio" name="${radioName}-${safeId}" value="replace" data-field="${keepField}" data-page-id="${safeId}"> Write our own</label>
          </div>
          <p style="font-size:10px; color:#999; margin-bottom:4px; font-style:italic;">"${fixedText}"</p>
          <textarea class="review-field-input" data-field="${customField}" data-page-id="${safeId}" rows="3" placeholder="${customPlaceholder}"></textarea>
        `;
        return `
          ${sectionHeader('The Graveside Committal')}
          ${field('mm_cemetery_name', 'Cemetery Name')}
          ${field('mm_cemetery_address', 'Address')}
          ${field('mm_committal_time', 'Time (e.g. 1:00 PM, Following the Funeral Service)')}
          <p style="font-size:10px; color:#999; margin-top:8px;">Ceremonial Note</p>
          ${keepOrReplace('mmCeremonialChoice', 'mm_ceremonial_choice', 'mm_ceremonial_custom', 'Ceremonial Note: The Priest seals the tomb by sprinkling earth and pouring sanctified oil over the casket in the sign of the Cross, proclaiming: "Earth thou art, and unto earth shalt thou return."', 'Only used if "Write our own" is selected above')}

          ${sectionHeader('The Makaria (Mercy Meal)')}
          <p style="font-size:10px; color:#999;">Introductory Text</p>
          ${keepOrReplace('mmMakariaChoice', 'mm_makaria_choice', 'mm_makaria_custom', "In the Orthodox tradition, family and friends gather to share the Makaria—a traditional meal of fish, bread, and wine—celebrating the soul's passage into life eternal.", 'Only used if "Write our own" is selected above')}
          ${field('mm_reception_location', 'Location')}
          ${field('mm_reception_address', 'Address')}
          ${field('mm_reception_time', 'Time (e.g. 2:30 PM – 5:30 PM)')}

          ${sectionHeader('Closing Scripture')}
          <p style="font-size:10px; color:#999; margin-bottom:2px; font-style:italic;">Feel free to keep this reference or choose a different verse.</p>
          <input type="text" class="review-field-input" data-field="mm_scripture_ref" data-page-id="${safeId}" value="Psalm 119:1 (LXX Psalm 118:1)" style="margin-top:6px;">
          <textarea class="review-field-input" data-field="mm_scripture_text" data-page-id="${safeId}" rows="2" placeholder="Type or paste the exact verse wording here" style="margin-top:6px;">Blessed is the way wherein you walk today, O soul, for there is prepared for you a place of everlasting rest.</textarea>
        `;
      }
      if (type === 'panikhida-schedule') {
        const sectionHeader = (label, sublabel) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 2px;">${label}</p>${sublabel ? `<p style="font-size:10px; color:#999; margin-bottom:6px; font-style:italic;">${sublabel}</p>` : ''}`;
        const field = (fieldName, placeholder) => `<input type="text" class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" placeholder="${placeholder}" style="margin-top:6px;">`;
        const scriptureBlock = (refField, versionField, textField, refValue, textValue) => `
          <input type="text" class="review-field-input" data-field="${refField}" data-page-id="${safeId}" value="${refValue}" style="margin-top:6px;">
          <select class="review-field-input" data-field="${versionField}" data-page-id="${safeId}" style="margin-top:6px;">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
          <textarea class="review-field-input" data-field="${textField}" data-page-id="${safeId}" rows="2" placeholder="Type or paste the exact verse wording here, in the version you chose above" style="margin-top:6px;">${textValue}</textarea>
        `;
        const commemoration = (label, sublabel, prefix) => `
          ${sectionHeader(label, sublabel)}
          ${field(prefix + '_date', 'Date (Day of Week, Month Day, Year)')}
          ${field(prefix + '_time', 'Time (e.g. 9:00 AM Divine Liturgy)')}
          ${field(prefix + '_location', 'Location (Parish Name, Sanctuary)')}
        `;
        return `
          ${sectionHeader('Opening Scripture')}
          <p style="font-size:10px; color:#999; margin-bottom:2px; font-style:italic;">Feel free to keep this reference or choose a different verse.</p>
          ${scriptureBlock('ps_scripture1_ref', 'ps_scripture1_version', 'ps_scripture1_text', 'Proverbs 10:7', 'The memory of the righteous is celebrated with praise.')}

          ${commemoration('Third-Day Commemoration', "In honor of the Holy Trinity and Christ's Resurrection on the third day. (fixed wording)", 'ps_third')}
          ${commemoration('Ninth-Day Commemoration', 'In honor of the nine angelic choirs interceding for the soul. (fixed wording)', 'ps_ninth')}
          ${commemoration('Fortieth-Day Memorial (The Sarandalitourgo)', "Marking the ascension of the soul, parallel to Christ's Ascension on the 40th day. Memorial Koliva (boiled wheat) will be blessed and distributed. (fixed wording)", 'ps_fortieth')}
          ${commemoration('Annual Memorial Service', 'A solemn commemoration marking the completion of one year of eternal rest. (fixed wording)', 'ps_annual')}

          ${sectionHeader('Parish Contact')}
          ${field('ps_parish_name', 'Parish Church Name')}
          ${field('ps_parish_address', 'Address')}
          ${field('ps_clergy_name', 'Clergy (Rev. Fr. ___, title)')}
          ${field('ps_parish_office', 'Parish Office Phone & Email')}

          ${sectionHeader('Closing Scripture')}
          <p style="font-size:10px; color:#999; margin-bottom:2px; font-style:italic;">Feel free to keep this reference or choose a different verse.</p>
          ${scriptureBlock('ps_scripture2_ref', 'ps_scripture2_version', 'ps_scripture2_text', '1 Thessalonians 4:14', 'For if we believe that Jesus died and rose again, even so God will bring with Him those who sleep in Jesus.')}
        `;
      }
      if (type === 'psalm-23') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The Psalm 23 text on this page is fixed and printed as shown. The only thing we need from you is which Bible version it's printed in.</p>
          <select class="review-field-input" data-field="p23_version" data-page-id="${safeId}">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
      }
      if (type === 'eccl-3-john-14') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The Ecclesiastes 3 and John 14 text on this page is fixed and printed as shown. The only thing we need from you is which Bible version it's printed in.</p>
          <select class="review-field-input" data-field="ej_version" data-page-id="${safeId}">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
      }
      if (type === '2-timothy-4') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The 2 Timothy 4 and Matthew 25 text on this page is fixed and printed as shown. The only thing we need from you is which Bible version it's printed in.</p>
          <select class="review-field-input" data-field="tt_version" data-page-id="${safeId}">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
      }
      if (type === 'psalm-91') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The Psalm 91 text on this page is fixed and printed as shown. The only thing we need from you is which Bible version it's printed in.</p>
          <select class="review-field-input" data-field="p91_version" data-page-id="${safeId}">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
      }
      if (type === 'lords-prayer') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The Lord's Prayer and Matthew 5:4 text on this page is fixed and printed as shown. The only thing we need from you is which Bible version it's printed in.</p>
          <select class="review-field-input" data-field="lp_version" data-page-id="${safeId}">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
      }
      if (type === 'psalm-121') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The Psalm 121 and Revelation 21:4 text on this page is fixed and printed as shown. The only thing we need from you is which Bible version it's printed in.</p>
          <select class="review-field-input" data-field="p121_version" data-page-id="${safeId}">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
      }
      if (type === 'isaiah-40-matthew-11') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The Isaiah 40 and Matthew 11 text on this page is fixed and printed as shown. The only thing we need from you is which Bible version it's printed in.</p>
          <select class="review-field-input" data-field="im_version" data-page-id="${safeId}">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
      }
      if (type === 'romans-8-rev-21') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The Romans 8 and Revelation 21 text on this page is fixed and printed as shown. The only thing we need from you is which Bible version it's printed in.</p>
          <select class="review-field-input" data-field="rr_version" data-page-id="${safeId}">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
      }
      if (type === '1-cor-13-2-cor-5') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The 1 Corinthians 13 and 2 Corinthians 5 text on this page is fixed and printed as shown. The only thing we need from you is which Bible version it's printed in.</p>
          <select class="review-field-input" data-field="cc_version" data-page-id="${safeId}">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
      }
      if (type === 'comfort-hope') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The Psalm 34/46 and John 11/1 Thessalonians 4 text on this page is fixed and printed as shown. The only thing we need from you is which Bible version it's printed in.</p>
          <select class="review-field-input" data-field="ch_version" data-page-id="${safeId}">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
      }
      if (type === 'prov-31-beatitudes') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The Proverbs 31 and Matthew 5 text on this page is fixed and printed as shown. The only thing we need from you is which Bible version it's printed in.</p>
          <select class="review-field-input" data-field="pb_version" data-page-id="${safeId}">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
      }
      if (type === 'psalm-62-phil-4') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The Psalm 62 and Philippians 4 text on this page is fixed and printed as shown. The only thing we need from you is which Bible version it's printed in.</p>
          <select class="review-field-input" data-field="pp_version" data-page-id="${safeId}">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
      }
      if (type === 'john-11-st-francis') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The John 11/Psalm 46 scripture and the Prayer of St. Francis on this page are fixed and printed as shown. The only thing we need from you is which Bible version the scripture is printed in.</p>
          <select class="review-field-input" data-field="jf_version" data-page-id="${safeId}">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
      }
      if (type === 'custom-text') {
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">This is a blank page — write anything you'd like here (a poem, a note, a reading, a memory, headings included).</p>
          <textarea class="review-field-input" data-field="ct_text" data-page-id="${safeId}" rows="10" placeholder="Write whatever you'd like for this page..."></textarea>
        `;
      }
      if (type === 'life-sketch') {
        const sectionHeader = (label) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 4px;">${label}</p>`;
        const field = (fieldName, placeholder) => `<input type="text" class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" placeholder="${placeholder}" style="margin-top:6px;">`;
        const bibleVersionDropdown = (fieldName) => `
          <select class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" style="margin-top:6px;">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
        return `
          ${sectionHeader('Early Years & Family')}
          ${field('ls_full_name', "Full name")}
          ${field('ls_dob', "Date of birth")}
          ${field('ls_birthplace', "City, State (where born)")}
          ${field('ls_parents', "Parents' names")}
          ${field('ls_spouse_name', "Spouse's full name")}
          ${field('ls_marriage_date', "Date of marriage")}
          ${field('ls_years_married', "Years of partnership (e.g. 42)")}

          ${sectionHeader('Dedication & Water Baptism')}
          ${field('ls_baptism_date', "Date of baptism")}
          ${field('ls_baptism_location', "Circuit Assembly / Regional Convention / City, State")}

          ${sectionHeader('Congregation & Ministry Privileges')}
          <p style="font-size:10px; color:#999; margin-bottom:6px;">Congregation name and years, plus any privileges that applied (Regular Pioneer, Elder, Ministerial Servant, Congregation Publisher, Kingdom Hall Construction & Maintenance, etc.) — write in whatever fits.</p>
          <textarea class="review-field-input" data-field="ls_congregation_privileges" data-page-id="${safeId}" rows="4" placeholder="e.g. Faithful member of the Riverside Congregation for 38 years. Served as a Regular Pioneer and Ministerial Servant."></textarea>

          ${sectionHeader('A Faithful Course')}
          <div style="display:flex; flex-direction:column; gap:6px; font-size:11px; margin-bottom:8px;">
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="radio" name="lsClosingChoice-${safeId}" value="standard" data-field="ls_closing_choice" data-page-id="${safeId}" checked> Use our standard wording, with their name added in</label>
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="radio" name="lsClosingChoice-${safeId}" value="custom" data-field="ls_closing_choice" data-page-id="${safeId}"> Write our own closing paragraph</label>
          </div>
          <p style="font-size:10px; color:#999; margin-bottom:6px; font-style:italic;">Standard wording: "[First Name] took great joy in sharing the good news of God's Kingdom with neighbors and friends, maintaining an unshakeable faith in the promise of a cleansed, peaceful earth."</p>
          <textarea class="review-field-input" data-field="ls_custom_closing" data-page-id="${safeId}" rows="3" placeholder="If you'd like your own wording instead, write it here"></textarea>

          ${sectionHeader('Scripture')}
          <p style="font-size:10px; color:#999; margin-bottom:4px;">Opening scripture (Job 14:15 shown as an example — change if you'd like a different verse)</p>
          <input type="text" class="review-field-input" data-field="ls_scripture_1_ref" data-page-id="${safeId}" value="Job 14:15">
          ${bibleVersionDropdown('ls_scripture_1_version')}
          <p style="font-size:10px; color:#999; margin:10px 0 4px;">Closing scripture (Isaiah 25:8 shown as an example — change if you'd like a different verse)</p>
          <input type="text" class="review-field-input" data-field="ls_scripture_2_ref" data-page-id="${safeId}" value="Isaiah 25:8">
          ${bibleVersionDropdown('ls_scripture_2_version')}
        `;
      }
      if (type === 'multi-scripture') {
        const bibleVersionDropdown = (fieldName) => `
          <select class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" style="margin-top:6px;">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
        const refs = multiScriptureConfig[pageId] || [];
        const refFields = refs.map((ref, i) => `
          <input type="text" class="review-field-input" data-field="scripture_${i + 1}_ref" data-page-id="${safeId}" value="${ref}" style="${i > 0 ? 'margin-top:8px;' : ''}">
        `).join('');
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:6px;">The scripture reference(s) below are shown as printed — feel free to change any of them to a different verse. If you'd like a different translation than the one selected, choose it here.</p>
          ${bibleVersionDropdown('scripture_version')}
          <p style="font-size:10px; color:#999; margin:10px 0 4px;">Scripture reference(s) for this page:</p>
          ${refFields}
        `;
      }
      if (type === 'family-gratitude') {
        const row = (whatValue) => `
          <div class="oos-row">
            <input type="text" class="review-field-input oos-what" value="${whatValue}">
            <input type="text" class="review-field-input oos-who" placeholder="Detail">
          </div>
        `;
        const sectionHeader = (label) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 4px;">${label}</p>`;
        const bibleVersionDropdown = (fieldName) => `
          <select class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" style="margin-top:6px;">
            <option value="">Bible Version — choose one</option>
            <option value="NWT" selected>NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">Each line below is fully yours to change on both sides — the label and the detail. Add more lines if you need them.</p>

          ${sectionHeader('Words of Appreciation')}
          <textarea class="review-field-input" data-field="gratitude_message" data-page-id="${safeId}" rows="4" placeholder="Write your family's thank-you message here"></textarea>

          ${sectionHeader('Burial & Interment')}
          <div class="oos-table" id="oosTable-${safeId}-burial">
            ${row('Cemetery or Memorial Park Name')}
            ${row('Address / Section Details')}
            ${row('City, State')}
            ${row('Officiating Brother')}
          </div>
          <span class="add-row-link" onclick="addOosRow('${safeId}-burial')">+ Add another line</span>

          ${sectionHeader('Gathering & Fellowship')}
          <div class="oos-table" id="oosTable-${safeId}-gathering">
            ${row('Location Name')}
            ${row('Street Address')}
            ${row('City, State')}
          </div>
          <span class="add-row-link" onclick="addOosRow('${safeId}-gathering')">+ Add another line</span>

          ${sectionHeader('Closing Scripture')}
          <input type="text" class="review-field-input" data-field="fg_scripture_ref" data-page-id="${safeId}" value="Psalm 34:18">
          ${bibleVersionDropdown('fg_scripture_version')}
        `;
      }
      if (type === 'faithful-course') {
        const themes = ['Public Ministry', 'Conventions & Assemblies', 'Volunteer Service', 'Family & Congregation'];
        const slots = themes.map((theme, i) => `
          <div style="margin-top:${i === 0 ? '0' : '14px'}; padding-top:${i === 0 ? '0' : '12px'}; border-top:${i === 0 ? 'none' : '1px solid #2a2a2a'};">
            <input type="text" class="review-field-input" data-field="fc_slot_${i + 1}_theme" data-page-id="${safeId}" value="${theme}">
            <textarea class="review-field-input" data-field="fc_slot_${i + 1}_caption" data-page-id="${safeId}" rows="2" placeholder="Optional caption or note for this photo" style="margin-top:6px;"></textarea>
          </div>
        `).join('');
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">This page has 4 photo spots, each with a theme shown below — feel free to leave the themes as-is or change them. When you email your photos, please name each file to match its theme (e.g. PublicMinistry.jpg) so we can match them correctly.</p>
          <input type="text" class="review-field-input" data-field="fc_scripture_top" data-page-id="${safeId}" value="Hebrews 13:7" style="margin-bottom:12px;">
          ${slots}
          <div style="margin-top:14px; padding-top:12px; border-top:1px solid #2a2a2a;">
            <input type="text" class="review-field-input" data-field="fc_scripture_bottom" data-page-id="${safeId}" value="Psalm 37:37">
          </div>
        `;
      }
      if (type === 'keep-or-replace-sections') {
        const sections = keepOrReplaceConfig[pageId] || [];
        const sectionHtml = sections.map((section, i) => {
          const n = i + 1;
          const refLine = section.ref ? `<p style="font-size:10px; color:#999; margin-bottom:6px;">As printed: ${section.ref}</p>` : '';
          const titlePlaceholder = section.replacementTitlePlaceholder || 'Song title & number, or scripture reference';
          return `
            <div style="margin-top:${i === 0 ? '0' : '14px'}; padding-top:${i === 0 ? '0' : '12px'}; border-top:${i === 0 ? 'none' : '1px solid #2a2a2a'};">
              <p style="font-size:11px; font-weight:600; color:#d4af37; margin-bottom:2px;">${section.label}</p>
              ${refLine}
              <div style="display:flex; flex-direction:column; gap:6px; font-size:11px; margin-bottom:8px;">
                <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="radio" name="korSection${n}-${safeId}" value="keep" data-field="kor_section${n}_choice" data-page-id="${safeId}" checked> Keep as printed</label>
                <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="radio" name="korSection${n}-${safeId}" value="replace" data-field="kor_section${n}_choice" data-page-id="${safeId}"> Replace with something else</label>
              </div>
              <input type="text" class="review-field-input" data-field="kor_section${n}_replacement_title" data-page-id="${safeId}" placeholder="${titlePlaceholder}">
              <textarea class="review-field-input" data-field="kor_section${n}_replacement_text" data-page-id="${safeId}" rows="3" placeholder="The text you'd like printed for this section" style="margin-top:6px;"></textarea>
            </div>
          `;
        }).join('');
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">Each section below can stay exactly as printed, or be replaced entirely with something else of your choosing. If you'd like to replace a section, please provide a short title and the text you'd like printed.</p>
          ${sectionHtml}
        `;
      }
      if (type === 'vigil-rosary') {
        const row = (whatValue) => `
          <div class="oos-row">
            <input type="text" class="review-field-input oos-what" value="${whatValue}">
            <input type="text" class="review-field-input oos-who" placeholder="Name">
          </div>
        `;
        const sectionHeader = (label) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 4px;">${label}</p>`;
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">Each line below is fully yours to change on both sides — the label and the name. Add more lines if you need them.</p>

          ${sectionHeader('Service Details')}
          <input type="text" class="review-field-input" data-field="vr_location" data-page-id="${safeId}" placeholder="Funeral Home Chapel / Parish Name">
          <input type="text" class="review-field-input" data-field="vr_date" data-page-id="${safeId}" placeholder="Date of Vigil" style="margin-top:6px;">
          <input type="text" class="review-field-input" data-field="vr_time" data-page-id="${safeId}" placeholder="Time of Service" style="margin-top:6px;">
          <input type="text" class="review-field-input" data-field="vr_presider" data-page-id="${safeId}" placeholder="Presider (Reverend / Deacon / Family Leader Name)" style="margin-top:6px;">

          ${sectionHeader('Introductory Rites')}
          <div class="oos-table" id="oosTable-${safeId}-intro">
            ${row('Gathering Hymn')}
            ${row('Greeting & Sign of the Cross')}
            ${row('Opening Prayer (Collect)')}
          </div>
          <span class="add-row-link" onclick="addOosRow('${safeId}-intro')">+ Add another line</span>

          ${sectionHeader('Liturgy of the Word')}
          <div class="oos-table" id="oosTable-${safeId}-word">
            ${row('Scripture Reading (Wisdom 3:1–9)')}
            ${row('Responsorial Psalm (Psalm 27)')}
            ${row('Gospel Proclamation (John 14:1–6)')}
            ${row('Homily or Words of Grace')}
          </div>
          <span class="add-row-link" onclick="addOosRow('${safeId}-word')">+ Add another line</span>

          ${sectionHeader('The Holy Rosary')}
          <div class="oos-table" id="oosTable-${safeId}-rosary">
            ${row('The Sign of the Cross & Apostles\\u2019 Creed')}
            ${row('The Our Father & Three Hail Marys')}
            ${row('The Sorrowful Mysteries')}
            ${row('Hail, Holy Queen (Salve Regina)')}
          </div>
          <span class="add-row-link" onclick="addOosRow('${safeId}-rosary')">+ Add another line</span>
          <p style="font-size:10px; color:#999; margin-top:6px; font-style:italic;">The Sorrowful Mysteries (The Agony in the Garden, The Scourging at the Pillar, The Crowning with Thorns, The Carrying of the Cross, The Crucifixion and Death) are recited as printed and don't need a name filled in.</p>

          ${sectionHeader('Words of Remembrance')}
          <div class="oos-table" id="oosTable-${safeId}-remembrance">
            ${row('Personal Tributes & Reflections')}
            ${row('A Life in Pictures (Memorial Video)')}
          </div>
          <span class="add-row-link" onclick="addOosRow('${safeId}-remembrance')">+ Add another line</span>

          ${sectionHeader('Concluding Rites')}
          <div class="oos-table" id="oosTable-${safeId}-concluding">
            ${row('Prayers of Intercession')}
            ${row('The Lord\\u2019s Prayer (Our Father)')}
            ${row('Concluding Prayer & Blessing')}
          </div>
          <span class="add-row-link" onclick="addOosRow('${safeId}-concluding')">+ Add another line</span>
        `;
      }
      if (type === 'rite-of-inurnment') {
        const sectionHeader = (label) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 4px;">${label}</p>`;
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">Fill in the details below — the blessing text stays as printed, with just the names and dates filled in.</p>

          ${sectionHeader('The Procession to the Niche')}
          <input type="text" class="review-field-input" data-field="ri_location_name" data-page-id="${safeId}" placeholder="Name of Cemetery, Memorial Park, or Parish Columbarium">
          <input type="text" class="review-field-input" data-field="ri_location_section" data-page-id="${safeId}" placeholder="Columbarium Garden / Niche Location / Section Details" style="margin-top:6px;">
          <input type="text" class="review-field-input" data-field="ri_location_city" data-page-id="${safeId}" placeholder="City, State" style="margin-top:6px;">
          <p style="font-size:10px; color:#999; margin:8px 0 2px;">Scripture (Genesis 2:7 shown as printed — change if you'd like a different verse)</p>
          <input type="text" class="review-field-input" data-field="ri_scripture_ref" data-page-id="${safeId}" value="Genesis 2:7">

          ${sectionHeader('The Blessing of the Resting Place')}
          <input type="text" class="review-field-input" data-field="ri_celebrant_name" data-page-id="${safeId}" placeholder="Name of Officiating Clergy">
          <input type="text" class="review-field-input" data-field="ri_decedent_name" data-page-id="${safeId}" placeholder="Name of Decedent" style="margin-top:6px;">
          <div class="oos-row" style="margin-top:6px;">
            <input type="text" class="review-field-input" data-field="ri_birth_year" data-page-id="${safeId}" placeholder="Birth Year">
            <input type="text" class="review-field-input" data-field="ri_death_year" data-page-id="${safeId}" placeholder="Death Year">
          </div>
          <textarea class="review-field-input" data-field="ri_hymn_antiphon" data-page-id="${safeId}" rows="2" placeholder="Optional — Committal Hymn or Antiphon, if you'd like one included" style="margin-top:8px;"></textarea>

          ${sectionHeader('Closing Line')}
          <input type="text" class="review-field-input" data-field="ri_closing_line" data-page-id="${safeId}" value="Grant them, O Lord, a dwelling place of peace and rest.">
        `;
      }
      if (type === 'resolution-of-respect') {
        const sectionHeader = (label) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 4px;">${label}</p>`;
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">The resolution wording stays as printed — just fill in the details below.</p>

          <input type="text" class="review-field-input" data-field="ror_deceased_name" data-page-id="${safeId}" placeholder="Full name of the deceased">
          <input type="text" class="review-field-input" data-field="ror_church_name" data-page-id="${safeId}" placeholder="Name of Church" style="margin-top:6px;">
          <input type="text" class="review-field-input" data-field="ror_pastor_at_joining" data-page-id="${safeId}" placeholder="Pastor's name at the time they joined" style="margin-top:6px;">
          <input type="text" class="review-field-input" data-field="ror_join_date" data-page-id="${safeId}" placeholder="Date / Year they joined" style="margin-top:6px;">

          ${sectionHeader('Ministries & Boards Served')}
          <div id="ministryList-${safeId}">
            <input type="text" class="review-field-input name-list-row" placeholder="e.g. The Senior Choir">
          </div>
          <span class="add-row-link" onclick="addNameRow('ministryList-${safeId}', 'e.g. The Usher Board')">+ Add another</span>

          ${sectionHeader('Date Submitted')}
          <input type="text" class="review-field-input" data-field="ror_submitted_date" data-page-id="${safeId}" placeholder="Day, Month, Year (e.g. 14th day of March, 2026)">

          ${sectionHeader('Signatures')}
          <input type="text" class="review-field-input" data-field="ror_pastor_name" data-page-id="${safeId}" placeholder="Pastor's full name">
          <input type="text" class="review-field-input" data-field="ror_clerk_name" data-page-id="${safeId}" placeholder="Church Clerk's name" style="margin-top:6px;">
        `;
      }
      if (type === 'service-of-committal') {
        const row = (whatValue) => `
          <div class="oos-row">
            <input type="text" class="review-field-input oos-what" value="${whatValue}">
            <input type="text" class="review-field-input oos-who" placeholder="Name">
          </div>
        `;
        const sectionHeader = (label) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 4px;">${label}</p>`;
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">Each line below is fully yours to change on both sides — the label and the name. The committal sentence and closing blessing are traditional and stay as printed.</p>

          ${sectionHeader('Service Details')}
          <input type="text" class="review-field-input" data-field="soc_cemetery_name" data-page-id="${safeId}" placeholder="Cemetery or Memorial Park Name">
          <input type="text" class="review-field-input" data-field="soc_section_plot" data-page-id="${safeId}" placeholder="Section Name / Plot Number" style="margin-top:6px;">
          <input type="text" class="review-field-input" data-field="soc_city_state" data-page-id="${safeId}" placeholder="City, State" style="margin-top:6px;">
          <input type="text" class="review-field-input" data-field="soc_officiant" data-page-id="${safeId}" placeholder="Officiant (Reverend Full Name)" style="margin-top:6px;">

          <p style="font-size:10px; color:#999; margin:10px 0 2px;">Opening scripture (John 11:25–26 shown as printed — change if you'd like a different verse)</p>
          <input type="text" class="review-field-input" data-field="soc_scripture_ref" data-page-id="${safeId}" value="John 11:25–26">

          ${sectionHeader('Order of Committal')}
          <div class="oos-table" id="oosTable-${safeId}">
            ${row('Gathering of the Bereaved')}
            ${row('Scripture Reading (1 Corinthians 15:51–57)')}
            ${row('The Committal Sentences')}
            ${row('The Lord\\u2019s Prayer (Debts & Debtors)')}
            ${row('The Pastoral Benediction')}
          </div>
          <span class="add-row-link" onclick="addOosRow('${safeId}')">+ Add another line</span>
          <p style="font-size:10px; color:#999; margin-top:8px; font-style:italic;">The Committal Sentences ("Forasmuch as it hath pleased Almighty God...") and the closing blessing (Numbers 6:24–26) are traditional wording recited as printed and don't need a name filled in.</p>
        `;
      }
      if (type === 'collage') {
        const quoteField = collageWithQuotePageIds.has(pageId)
          ? `<textarea class="review-field-input" data-field="collage_quote" data-page-id="${safeId}" rows="2" placeholder="Optional — a short quote or verse to go with this page"></textarea>`
          : '';
        const count = collagePhotoCount(pageId);
        const countLine = count
          ? `This layout holds <strong>${count} photo${count === 1 ? '' : 's'}</strong>.`
          : `This layout uses a set number of photos.`;
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:6px;">${countLine} Once you've approved your final selections, simply email your photos to photos@notedandcharmed.com with your order number in the subject line — that's all it takes. We'll also total up your full photo count, including your cover photo, at the end.</p>
          ${quoteField}
        `;
      }
      if (type === 'photo-tributes') {
        const slots = [1,2,3,4,5,6].map(n => `
          <div style="margin-top:${n === 1 ? '0' : '14px'}; padding-top:${n === 1 ? '0' : '12px'}; border-top:${n === 1 ? 'none' : '1px solid #2a2a2a'};">
            <input type="text" class="review-field-input" data-field="tribute_${n}_name" data-page-id="${safeId}" placeholder="Name (Slot ${n})">
            <textarea class="review-field-input" data-field="tribute_${n}_text" data-page-id="${safeId}" rows="2" placeholder="Their tribute — what they'd like to say" style="margin-top:6px;"></textarea>
          </div>
        `).join('');
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">This page has 6 spots for a photo paired with someone's words. Use as many or as few as you'd like — leave the rest blank. When you email your photos, please name each file to match the person's name above their tribute (e.g. Sarah.jpg) so we can match them correctly.</p>
          ${slots}
        `;
      }
      if (type === 'note-only') {
        return `<p style="font-size:11px; color:#b8b3a8;">This page is printed as shown — nothing to fill in here. Use the note box below if there's anything you'd like us to know about it.</p>`;
      }
      if (type === 'christian-walk') {
        const sectionHeader = (label) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 4px;">${label}</p>`;
        const bibleVersionDropdown = (fieldName) => `
          <select class="review-field-input" data-field="${fieldName}" data-page-id="${safeId}" style="margin-top:6px;">
            <option value="">Bible Version — choose one</option>
            <option value="NWT">NWT (New World Translation)</option>
            <option value="KJV">KJV (King James Version)</option>
            <option value="NIV">NIV (New International Version)</option>
          </select>
        `;
        return `
          ${sectionHeader('Spiritual Rebirth & Baptism')}
          <input type="text" class="review-field-input" data-field="cw_salvation_date" data-page-id="${safeId}" placeholder="Year or Date of Salvation">
          <input type="text" class="review-field-input" data-field="cw_baptism_church" data-page-id="${safeId}" placeholder="Baptized at — Church Name, City, State" style="margin-top:6px;">
          <input type="text" class="review-field-input" data-field="cw_officiating_pastor" data-page-id="${safeId}" placeholder="Officiating Pastor" style="margin-top:6px;">

          ${sectionHeader('Membership & Covenant')}
          <input type="text" class="review-field-input" data-field="cw_home_church" data-page-id="${safeId}" placeholder="Primary Home Church">
          <input type="text" class="review-field-input" data-field="cw_pastor_name" data-page-id="${safeId}" placeholder="Pastor's Name" style="margin-top:6px;">
          <input type="text" class="review-field-input" data-field="cw_years_service" data-page-id="${safeId}" placeholder="Years of Faithful and Active Service" style="margin-top:6px;">

          ${sectionHeader('Ministry & Leadership')}
          <div id="ministryLeadershipList-${safeId}">
            <input type="text" class="review-field-input name-list-row" placeholder="e.g. Ordained as Deacon on [Date]">
          </div>
          <span class="add-row-link" onclick="addNameRow('ministryLeadershipList-${safeId}', 'e.g. Superintendent of the Sunday School Department')">+ Add another</span>

          ${sectionHeader('Community & Missionary Outreach')}
          <div id="outreachList-${safeId}">
            <input type="text" class="review-field-input name-list-row" placeholder="e.g. Volunteer with the Community Soup Kitchen">
          </div>
          <span class="add-row-link" onclick="addNameRow('outreachList-${safeId}', 'e.g. Missionary Society Leader')">+ Add another</span>

          ${sectionHeader('Scripture')}
          <p style="font-size:10px; color:#999; margin-bottom:4px;">Opening scripture (Matthew 5:16 shown as printed)</p>
          <input type="text" class="review-field-input" data-field="cw_scripture_1_ref" data-page-id="${safeId}" value="Matthew 5:16">
          ${bibleVersionDropdown('cw_scripture_1_version')}
          <p style="font-size:10px; color:#999; margin:10px 0 4px;">Middle scripture (Matthew 25:40 shown as printed)</p>
          <input type="text" class="review-field-input" data-field="cw_scripture_2_ref" data-page-id="${safeId}" value="Matthew 25:40">
          ${bibleVersionDropdown('cw_scripture_2_version')}
          <p style="font-size:10px; color:#999; margin:10px 0 4px;">Closing scripture (Revelation 14:13 shown as printed)</p>
          <input type="text" class="review-field-input" data-field="cw_scripture_3_ref" data-page-id="${safeId}" value="Revelation 14:13">
          ${bibleVersionDropdown('cw_scripture_3_version')}
        `;
      }
      if (type === 'repast-fellowship') {
        const sectionHeader = (label) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 4px;">${label}</p>`;
        return `
          <p style="font-size:10px; color:#999; margin-bottom:4px;">Opening scripture (Acts 2:46–47 shown as printed — change if you'd like a different verse)</p>
          <input type="text" class="review-field-input" data-field="rf_scripture_ref" data-page-id="${safeId}" value="Acts 2:46–47">

          ${sectionHeader('Fellowship Gathering')}
          <input type="text" class="review-field-input" data-field="rf_venue_name" data-page-id="${safeId}" placeholder="Fellowship Hall / Banquet Center Name">
          <input type="text" class="review-field-input" data-field="rf_venue_address" data-page-id="${safeId}" placeholder="Facility Address" style="margin-top:6px;">
          <input type="text" class="review-field-input" data-field="rf_venue_city" data-page-id="${safeId}" placeholder="City, State, Zip Code" style="margin-top:6px;">

          ${sectionHeader('Table Grace')}
          <p style="font-size:10px; color:#999; margin-bottom:6px;">Feel free to leave this prayer as printed (with your loved one's name added in) or write your own.</p>
          <input type="text" class="review-field-input" data-field="rf_grace_name" data-page-id="${safeId}" placeholder="First name to use in the prayer">
          <textarea class="review-field-input" data-field="rf_grace_custom_text" data-page-id="${safeId}" rows="4" placeholder="Optional — write your own Table Grace here instead" style="margin-top:6px;"></textarea>

          ${sectionHeader('Expressions of Love')}
          <div style="background:#0f1011; border:1px solid #282b2e; border-radius:3px; padding:8px 10px; margin-bottom:8px; font-size:10px; color:#b8b3a8; line-height:1.5;">Following the blessing of the table, opportunity will be given for brief personal reflections, fond memories, and remarks from friends.</div>
          <div style="display:flex; flex-direction:column; gap:6px; font-size:11px; margin-bottom:8px;">
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="radio" name="rfExpressionsChoice-${safeId}" value="keep" data-field="rf_expressions_choice" data-page-id="${safeId}" checked> Keep as printed (shown above)</label>
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="radio" name="rfExpressionsChoice-${safeId}" value="replace" data-field="rf_expressions_choice" data-page-id="${safeId}"> Replace with something else</label>
          </div>
          <textarea class="review-field-input" data-field="rf_expressions_replacement" data-page-id="${safeId}" rows="3" placeholder="If replacing, write what you'd like printed here instead"></textarea>
        `;
      }
      if (type === 'expressions-of-gratitude') {
        const sectionHeader = (label) => `<p style="font-size:11px; font-weight:600; color:#d4af37; margin:14px 0 4px;">${label}</p>`;
        const keepReplaceSection = (fieldPrefix, label, previewText) => `
          ${sectionHeader(label)}
          <div style="background:#0f1011; border:1px solid #282b2e; border-radius:3px; padding:8px 10px; margin-bottom:8px; font-size:10px; color:#b8b3a8; line-height:1.5; white-space:pre-line;">${previewText}</div>
          <div style="display:flex; flex-direction:column; gap:6px; font-size:11px; margin-bottom:8px;">
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="radio" name="${fieldPrefix}Choice-${safeId}" value="keep" data-field="${fieldPrefix}_choice" data-page-id="${safeId}" checked> Keep as printed (shown above)</label>
            <label style="display:flex; align-items:center; gap:6px; cursor:pointer;"><input type="radio" name="${fieldPrefix}Choice-${safeId}" value="replace" data-field="${fieldPrefix}_choice" data-page-id="${safeId}"> Replace with something else</label>
          </div>
          <textarea class="review-field-input" data-field="${fieldPrefix}_replacement" data-page-id="${safeId}" rows="4" placeholder="If replacing, write what you'd like printed here instead"></textarea>
        `;
        return `
          <p style="font-size:11px; color:#b8b3a8; margin-bottom:10px;">Each section below can stay exactly as printed, or be replaced with your own words.</p>
          ${keepReplaceSection('eog_poem', 'The Poem', "Perhaps you sent a lovely card,\nor sat quietly in a chair;\nPerhaps you sent those beautiful flowers,\nthat we saw sitting there;\nPerhaps you spoke the kindest words,\nas any friend could say;\nPerhaps you were not there at all,\njust thought of us that day.\nWhatever you did to console our hearts,\nWe thank you so much, whatever the part.")}
          ${keepReplaceSection('eog_message', 'Our Sincere Thanks (message)', "The family wishes to express our deepest appreciation to each of you for your love, kindness, and support during this tender time. For every telephone call, visit, warm meal, floral arrangement, and quiet prayer offered on our behalf, we are truly grateful. Your presence and comforting words have sustained us through our sorrow. May God bless and keep each of you in the days ahead.")}

          ${sectionHeader('Arrangements Entrusted To')}
          <input type="text" class="review-field-input" data-field="eog_funeral_home_name" data-page-id="${safeId}" placeholder="Mortuary / Funeral Home Name">
          <input type="text" class="review-field-input" data-field="eog_funeral_home_city" data-page-id="${safeId}" placeholder="City, State" style="margin-top:6px;">
        `;
      }
      // text-tribute default
      return `<textarea class="review-field-input" data-field="tribute_text" data-page-id="${safeId}" rows="4" placeholder="Write or paste your text for this page (optional — leave blank to use our standard wording)"></textarea>`;
    }

    function addOosRow(safeId) {
      const table = document.getElementById('oosTable-' + safeId);
      if (!table) return;
      const row = document.createElement('div');
      row.className = 'oos-row';
      row.innerHTML = `
        <input type="text" class="review-field-input oos-what" placeholder="What">
        <input type="text" class="review-field-input oos-who" placeholder="Who (name)">
      `;
      table.appendChild(row);
    }

    function addAckRow(safeId) {
      const table = document.getElementById('ackTable-' + safeId);
      if (!table) return;
      const row = document.createElement('div');
      row.className = 'oos-row';
      row.innerHTML = `
        <input type="text" class="review-field-input oos-what" placeholder="What / Role">
        <input type="text" class="review-field-input oos-who" placeholder="Name">
      `;
      table.appendChild(row);
    }

    function addNameRow(listId, placeholder) {
      const list = document.getElementById(listId);
      if (!list) return;
      const input = document.createElement('input');
      input.type = 'text';
      input.className = 'review-field-input name-list-row';
      input.placeholder = placeholder || 'Name';
      input.style.marginTop = '6px';
      list.appendChild(input);
    }

    function checkObituaryLength(textarea) {
      const safeId = textarea.getAttribute('data-page-id');
      const note = document.getElementById('obitNote-' + safeId);
      if (!note) return;
      const len = textarea.value.length;
      if (len > 1000) {
        note.textContent = `${len} characters — this is running long. Depending on length, we may need to reduce the font size slightly or continue it onto a second page. We'll follow up by email if any adjustment is needed.`;
        note.style.color = '#e0b0b0';
      } else {
        note.textContent = `${len} characters`;
        note.style.color = '#999';
      }
    }

    function renderSelectedThumbnails() {
      const stripContainer = document.getElementById('selectedThumbsGrid');
      const stripEmptyMsg = document.getElementById('selectedThumbsEmpty');
      if (!stripContainer) return;
      const pageIds = Object.keys(selectedPages);
      stripContainer.innerHTML = '';

      if (pageIds.length === 0) {
        if (stripEmptyMsg) stripEmptyMsg.style.display = 'block';
        stripContainer.style.display = 'none';
        return;
      }
      if (stripEmptyMsg) stripEmptyMsg.style.display = 'none';
      stripContainer.style.display = 'grid';

      pageIds.forEach(pid => {
        const title = selectedPages[pid].title;
        const tile = document.createElement('div');
        tile.className = 'selected-thumb-tile';
        tile.innerHTML = `
          <div class="selected-thumb-click" onclick="scrollToPageCard('${pid}')">${title}</div>
          <button type="button" class="selected-thumb-remove" onclick="removeSelectedPage('${pid}')">Remove</button>
        `;
        stripContainer.appendChild(tile);
      });
    }

    function scrollToPageCard(pageId) {
      const pageIds = Object.keys(selectedPages);
      const index = pageIds.indexOf(pageId);
      if (index === -1) return;
      reviewStepIndex = index + 1; // +1 because step 0 is Contact Info
      updateReviewStepVisibility();
      const scrollTarget = document.getElementById('reviewStepScrollAnchor');
      if (scrollTarget) scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const card = document.querySelector(`.review-page-card[data-page-id="${pageId}"]`);
      if (card) {
        card.style.borderColor = '#d4af37';
        setTimeout(() => { card.style.borderColor = ''; }, 1200);
      }
    }

    function removeSelectedPage(pageId) {
      const title = selectedPages[pageId] ? selectedPages[pageId].title : 'this page';
      const confirmed = confirm(`Remove "${title}" from your program? Any fields you've filled out or changed on this page will be lost.`);
      if (!confirmed) return;
      delete selectedPages[pageId];
      document.querySelectorAll(`.page-select-cb[data-page-id="${pageId}"]`).forEach(cb => { cb.checked = false; });
      document.querySelectorAll(`.folio-mini[data-page-id="${pageId}"]`).forEach(el => { el.classList.remove('is-selected'); });
      updateBudgetTrackers();
      renderReviewSlide();
      saveProgress();
    }

    function renderReviewSlide() {
      const container = document.getElementById('reviewPagesContainer');
      const emptyMsg = document.getElementById('reviewEmptyMsg');
      renderSelectedThumbnails();
      if (!container) return;
      const pageIds = Object.keys(selectedPages);

      // Remove all previously-rendered page cards (the contact info box lives outside this container now, so it's untouched)
      container.querySelectorAll('.review-page-card').forEach(el => el.remove());

      if (pageIds.length === 0) {
        if (emptyMsg) emptyMsg.style.display = 'block';
        return;
      }
      if (emptyMsg) emptyMsg.style.display = 'none';

      pageIds.forEach(pid => {
        const title = selectedPages[pid].title;
        const type = getPageType(pid);
        const safeId = pid.replace(/[^a-z0-9-]/g, '');
        const card = document.createElement('div');
        card.className = 'review-page-card';
        card.setAttribute('data-page-id', pid);
        card.innerHTML = `
          <h3>${title}</h3>
          ${fieldHtmlFor(pid, title, type)}
          <div style="margin-top:12px; padding-top:10px; border-top:1px solid #2a2a2a;">
            <textarea class="review-field-input" data-field="page_note" data-page-id="${safeId}" rows="2" placeholder="Anything else about this page you'd like us to know? (optional)"></textarea>
          </div>
        `;
        container.appendChild(card);
      });

      renderOrderConfirmBlock();
      updateReviewStepVisibility();
    }

    // ===== ONE-AT-A-TIME STEP NAVIGATION WITHIN "YOUR SELECTED PAGES" =====
    // Step 0 = Contact Info, steps 1..N = each selected page card in order, step N+1 = Order & Confirm/Submit
    let reviewStepIndex = 0;

    function getReviewStepCount() {
      const pageIds = Object.keys(selectedPages);
      return pageIds.length + 2; // contact info + N pages + order/confirm
    }

    function updateReviewStepVisibility() {
      const contactCard = document.getElementById('contactInfoCard');
      const cards = document.querySelectorAll('.review-page-card');
      const orderBlock = document.getElementById('orderConfirmBlock');
      const stepCount = getReviewStepCount();

      if (reviewStepIndex > stepCount - 1) reviewStepIndex = stepCount - 1;
      if (reviewStepIndex < 0) reviewStepIndex = 0;

      if (contactCard) contactCard.style.display = (reviewStepIndex === 0) ? 'block' : 'none';
      cards.forEach((card, i) => {
        card.style.display = (reviewStepIndex === i + 1) ? 'block' : 'none';
      });
      const onOrderStep = reviewStepIndex === stepCount - 1;
      if (orderBlock) {
        // orderConfirmBlock's own display:none/block still applies when there are zero pages selected
        if (Object.keys(selectedPages).length > 0) {
          orderBlock.style.display = onOrderStep ? 'block' : 'none';
        }
      }
      const submitWrap = document.getElementById('submitButtonWrap');
      if (submitWrap) submitWrap.style.display = onOrderStep ? 'flex' : 'none';

      const stepLabel = document.getElementById('reviewStepLabel');
      if (stepLabel) {
        if (reviewStepIndex === 0) {
          stepLabel.textContent = 'Contact Information';
        } else if (onOrderStep) {
          stepLabel.textContent = 'Order Your Pages & Submit';
        } else {
          const pid = Object.keys(selectedPages)[reviewStepIndex - 1];
          stepLabel.textContent = pid ? selectedPages[pid].title : '';
        }
      }
      const stepCounter = document.getElementById('reviewStepCounter');
      if (stepCounter) stepCounter.textContent = `Step ${reviewStepIndex + 1} of ${stepCount}`;

      const prevBtn = document.getElementById('reviewStepPrev');
      const nextBtn = document.getElementById('reviewStepNext');
      if (prevBtn) prevBtn.style.visibility = (reviewStepIndex === 0) ? 'hidden' : 'visible';
      if (nextBtn) nextBtn.style.visibility = onOrderStep ? 'hidden' : 'visible';
    }

    function changeReviewStep(delta) {
      reviewStepIndex += delta;
      updateReviewStepVisibility();
      const scrollTarget = document.getElementById('reviewStepScrollAnchor');
      if (scrollTarget) scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }


    // ===== PAGE ORDER + FINAL CONFIRM =====
    let pageOrderAssignments = {}; // { pageId: positionNumber }

    function renderOrderConfirmBlock() {
      const block = document.getElementById('orderConfirmBlock');
      const listEl = document.getElementById('pageOrderList');
      if (!block || !listEl) return;
      const pageIds = Object.keys(selectedPages);

      if (pageIds.length === 0) {
        block.style.display = 'none';
        return;
      }
      block.style.display = 'block';

      // Drop any assignments for pages that are no longer selected
      Object.keys(pageOrderAssignments).forEach(pid => {
        if (!selectedPages[pid]) delete pageOrderAssignments[pid];
      });

      listEl.innerHTML = '';
      pageIds.forEach(pid => {
        const title = selectedPages[pid].title;
        const row = document.createElement('div');
        row.className = 'page-order-row';
        row.setAttribute('data-page-id', pid);
        const options = ['<option value="">—</option>'];
        for (let i = 1; i <= pageBudget; i++) {
          const selected = pageOrderAssignments[pid] === i ? 'selected' : '';
          options.push(`<option value="${i}" ${selected}>Page ${i}</option>`);
        }
        row.innerHTML = `
          <span>${title}</span>
          <select class="page-order-select" onchange="setPageOrder('${pid}', this.value)">${options.join('')}</select>
        `;
        listEl.appendChild(row);
      });

      renderPhotoCountSummary(pageIds);
      validatePageOrder();
    }

    // Tallies photos needed across selected collage pages, plus one for the front cover,
    // and renders a small itemized breakdown with the grand total shown prominently.
    function renderPhotoCountSummary(pageIds) {
      const summaryEl = document.getElementById('photoCountSummary');
      const totalEl = document.getElementById('photoCountTotal');
      const breakdownEl = document.getElementById('photoCountBreakdown');
      if (!summaryEl || !totalEl || !breakdownEl) return;

      const collageIds = pageIds.filter(isCollagePageId);
      if (collageIds.length === 0) {
        summaryEl.style.display = 'none';
        return;
      }

      const lineItems = [];
      let total = 1; // front cover photo, always needed
      let hasUnknownCount = false;

      collageIds.forEach(pid => {
        const title = selectedPages[pid].title;
        const count = collagePhotoCount(pid);
        if (count) {
          total += count;
          lineItems.push(`${title}: ${count}`);
        } else {
          hasUnknownCount = true;
          lineItems.push(`${title}: TBD`);
        }
      });
      lineItems.push('Front cover: 1');

      totalEl.textContent = hasUnknownCount
        ? `📸 You'll need at least ${total} photos`
        : `📸 You'll need ${total} photo${total === 1 ? '' : 's'} total`;
      breakdownEl.textContent = lineItems.join(' · ');
      summaryEl.style.display = 'block';
    }

    function setPageOrder(pageId, value) {
      if (value === '') {
        delete pageOrderAssignments[pageId];
      } else {
        pageOrderAssignments[pageId] = parseInt(value, 10);
      }
      validatePageOrder();
      saveProgress();
    }

    function validatePageOrder() {
      const pageIds = Object.keys(selectedPages);
      const warning = document.getElementById('pageOrderWarning');
      const usedNumbers = {};
      let hasDuplicate = false;

      document.querySelectorAll('.page-order-row').forEach(row => row.classList.remove('is-duplicate'));

      pageIds.forEach(pid => {
        const num = pageOrderAssignments[pid];
        if (num === undefined) return;
        if (usedNumbers[num]) {
          hasDuplicate = true;
          usedNumbers[num].push(pid);
        } else {
          usedNumbers[num] = [pid];
        }
      });

      let allDuplicatePageIds = [];
      Object.values(usedNumbers).forEach(pids => {
        if (pids.length > 1) allDuplicatePageIds = allDuplicatePageIds.concat(pids);
      });
      allDuplicatePageIds.forEach(pid => {
        const row = document.querySelector(`.page-order-row[data-page-id="${pid}"]`);
        if (row) row.classList.add('is-duplicate');
      });

      const allAssigned = pageIds.every(pid => pageOrderAssignments[pid] !== undefined);
      const isValid = allAssigned && !hasDuplicate && pageIds.length > 0;

      if (warning) warning.style.display = (pageIds.length > 0 && !isValid) ? 'block' : 'none';
      updateSubmitGate();
      return isValid;
    }

    function updateSubmitGate() {
      const btn = document.getElementById('submitSelectionsBtn');
      if (!btn) return;
      const pageIds = Object.keys(selectedPages);
      const orderValid = pageIds.length === 0 ? true : (
        pageIds.every(pid => pageOrderAssignments[pid] !== undefined) &&
        new Set(Object.values(pageOrderAssignments)).size === pageIds.length
      );
      const confirmed = document.getElementById('reviewConfirmedCheckbox')?.checked;
      const budgetMet = pageBudget > 0 && pageIds.length === pageBudget;
      const canSubmit = budgetMet && orderValid && confirmed;
      btn.disabled = !canSubmit;
      btn.style.opacity = canSubmit ? '1' : '0.5';
      btn.style.cursor = canSubmit ? 'pointer' : 'not-allowed';

      const gateMsg = document.getElementById('submitGateMsg');
      if (gateMsg) {
        if (canSubmit || pageBudget === 0) {
          gateMsg.style.display = 'none';
        } else if (pageIds.length < pageBudget) {
          const remaining = pageBudget - pageIds.length;
          gateMsg.textContent = `Please select ${remaining} more page${remaining === 1 ? '' : 's'} to fill your ${pageBudget}-page program before submitting.`;
          gateMsg.style.display = 'block';
        } else if (pageIds.length > pageBudget) {
          gateMsg.textContent = `You've selected more pages than your ${pageBudget}-page program includes — please remove some before submitting.`;
          gateMsg.style.display = 'block';
        } else if (!orderValid) {
          gateMsg.textContent = 'Please give every page a unique position before submitting.';
          gateMsg.style.display = 'block';
        } else if (!confirmed) {
          gateMsg.textContent = 'Please confirm you\'ve reviewed everything above before submitting.';
          gateMsg.style.display = 'block';
        } else {
          gateMsg.style.display = 'none';
        }
      }
    }

    document.addEventListener('change', (e) => {
      if (e.target && e.target.id === 'reviewConfirmedCheckbox') {
        updateSubmitGate();
        saveProgress();
      }
      if (e.target && e.target.name === 'spellcheckPref') {
        saveProgress();
      }
    });

    function gatherPageFieldData(pageId) {
      const safeId = pageId.replace(/[^a-z0-9-]/g, '');
      const type = getPageType(pageId);
      const data = {};

      const gatherOosTable = (tableId) => {
        const table = document.getElementById(tableId);
        const rows = table ? table.querySelectorAll('.oos-row') : [];
        const lines = [];
        rows.forEach(row => {
          const what = row.querySelector('.oos-what')?.value || '';
          const who = row.querySelector('.oos-who')?.value || '';
          if (what || who) lines.push(`${what || '(untitled)'} — ${who.trim() ? who : 'not provided'}`);
        });
        return lines.join('\n');
      };
      // For tables where the left side is always pre-filled with a default label (Acknowledgments,
      // Honored Service Details) — the section as a whole only counts as real content if at least one
      // name/detail was actually typed on the right. But each line still keeps its own label text
      // (edited or original) with "not provided" only on the blank name side, so the label a customer
      // is meant to match against (e.g. for photo filenames) is never lost from the email.
      const gatherOosTableIfAnswered = (tableId) => {
        const table = document.getElementById(tableId);
        const rows = table ? table.querySelectorAll('.oos-row') : [];
        const lines = [];
        let anyWhoFilled = false;
        rows.forEach(row => {
          const what = row.querySelector('.oos-what')?.value || '';
          const who = row.querySelector('.oos-who')?.value || '';
          if (who.trim()) anyWhoFilled = true;
          if (what || who) lines.push(`${what || '(untitled)'} — ${who.trim() ? who : 'not provided'}`);
        });
        return anyWhoFilled ? lines.join('\n') : '';
      };
      const gatherPallbearerGroup = (fieldPrefix, count) => {
        const names = [];
        for (let i = 1; i <= count; i++) {
          const val = document.querySelector(`[data-field="${fieldPrefix}_${i}"][data-page-id="${safeId}"]`)?.value || '';
          if (val) names.push(val);
        }
        return names.join(', ');
      };
      const gatherNameList = (listId) => {
        const list = document.getElementById(listId);
        if (!list) return '';
        const names = [];
        list.querySelectorAll('.name-list-row').forEach(input => {
          if (input.value) names.push(input.value);
        });
        return names.join('; ');
      };

      if (type === 'obituary') {
        const el = document.querySelector(`.review-field-input[data-field="obituary_text"][data-page-id="${safeId}"]`);
        data.obituary_text = el ? el.value : '';
      } else if (type === 'order-of-service') {
        data.order_of_service_lines = gatherOosTable('oosTable-' + safeId);
        data.pallbearers = gatherPallbearerGroup('pallbearer', 6);
        data.honorary_pallbearers = gatherPallbearerGroup('honorary_pallbearer', 4);
        data.special_acknowledgments = gatherOosTableIfAnswered('ackTable-' + safeId);
      } else if (type === 'jw-memorial-service') {
        ['congregation','address','service_date','service_time','scripture'].forEach(f => {
          data['jw_' + f] = document.querySelector(`[data-field="jw_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
        for (let i = 1; i <= 6; i++) {
          data[`jw_part${i}_role`] = document.querySelector(`[data-field="jw_part${i}_role"][data-page-id="${safeId}"]`)?.value || '';
          data[`jw_part${i}_name`] = document.querySelector(`[data-field="jw_part${i}_name"][data-page-id="${safeId}"]`)?.value || '';
        }
        data.jw_zoom_id = document.querySelector(`[data-field="jw_zoom_id"][data-page-id="${safeId}"]`)?.value || '';
        data.jw_zoom_passcode = document.querySelector(`[data-field="jw_zoom_passcode"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'ministry-of-music') {
        data.musical_selections = gatherOosTable('oosTable-' + safeId);
        data.minister_of_music = document.querySelector(`[data-field="minister_of_music"][data-page-id="${safeId}"]`)?.value || '';
        data.organist_name = document.querySelector(`[data-field="organist_name"][data-page-id="${safeId}"]`)?.value || '';
        data.pianist_name = document.querySelector(`[data-field="pianist_name"][data-page-id="${safeId}"]`)?.value || '';
        data.percussion_name = document.querySelector(`[data-field="percussion_name"][data-page-id="${safeId}"]`)?.value || '';
        data.lead_guitar_name = document.querySelector(`[data-field="lead_guitar_name"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'catholic-mass') {
        data.order_of_service_lines = gatherOosTable('oosTable-' + safeId);
        data.pallbearers = gatherPallbearerGroup('pallbearer', 6);
        data.special_acknowledgments = gatherOosTableIfAnswered('ackTable-' + safeId);
      } else if (type === 'homegoing-celebration' || type === 'orthodox-burial' || type === 'military-honors' || type === 'first-responder-honors') {
        data.order_of_service_lines = gatherOosTable('oosTable-' + safeId);
        data.pallbearers = gatherPallbearerGroup('pallbearer', 6);
        data.honorary_pallbearers = gatherPallbearerGroup('honorary_pallbearer', 4);
        data.special_acknowledgments = gatherOosTableIfAnswered('ackTable-' + safeId);
        if (type === 'military-honors' || type === 'first-responder-honors') {
          data.honored_service_details = gatherOosTableIfAnswered('detailsTable-' + safeId);
        }
      } else if (type === 'collage') {
        data.collage_quote = document.querySelector(`[data-field="collage_quote"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'photo-tributes') {
        for (let i = 1; i <= 6; i++) {
          const name = document.querySelector(`[data-field="tribute_${i}_name"][data-page-id="${safeId}"]`)?.value || '';
          const text = document.querySelector(`[data-field="tribute_${i}_text"][data-page-id="${safeId}"]`)?.value || '';
          if (name || text) {
            data[`tribute_${i}_name`] = name;
            data[`tribute_${i}_text`] = text;
          }
        }
      } else if (type === 'family-lineage') {
        data.gen1_person1 = document.querySelector(`[data-field="gen1_person1"][data-page-id="${safeId}"]`)?.value || '';
        data.gen1_person2 = document.querySelector(`[data-field="gen1_person2"][data-page-id="${safeId}"]`)?.value || '';
        data.generation_2_names = gatherNameList('gen2List-' + safeId);
        data.generation_3_names = gatherNameList('gen3List-' + safeId);
        data.grandchildren_names = document.querySelector(`[data-field="grandchildren_names"][data-page-id="${safeId}"]`)?.value || '';
        data.great_grandchildren_names = document.querySelector(`[data-field="great_grandchildren_names"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'generational-legacy') {
        data.photo_id_note = document.querySelector(`[data-field="gl_photo_id_note"][data-page-id="${safeId}"]`)?.value || '';
        data.dedication_name = document.querySelector(`[data-field="gl_dedication_name"][data-page-id="${safeId}"]`)?.value || '';
        data.scripture_reference = document.querySelector(`[data-field="gl_scripture_ref"][data-page-id="${safeId}"]`)?.value || '';
        data.scripture_version = document.querySelector(`[data-field="gl_scripture_version"][data-page-id="${safeId}"]`)?.value || '';
        data.scripture_text = document.querySelector(`[data-field="gl_scripture_text"][data-page-id="${safeId}"]`)?.value || '';
        data.tribute_text = document.querySelector(`[data-field="gl_tribute_text"][data-page-id="${safeId}"]`)?.value || '';
        data.grandchildren_names = gatherNameList('glGrandkidsList-' + safeId);
        data.great_grandchildren_names = gatherNameList('glGreatGrandkidsList-' + safeId);
        data.great_great_grandchildren_names = gatherNameList('glGreatGreatGrandkidsList-' + safeId);
      } else if (type === 'life-in-church') {
        ['scripture1_ref','scripture1_version','scripture1_text','baptismal_name','patron_saint','name_day',
         'baptism_date','baptism_parish','matrimony_date','spouse_name','home_parish','fellowship_years',
         'sanctuary_service','ancestral_homeland','immigration_year','port_of_entry','family_icon',
         'life_of_prayer','scripture2_ref','scripture2_version','scripture2_text'].forEach(f => {
          data['lic_' + f] = document.querySelector(`[data-field="lic_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
        data.godparents_names = gatherNameList('licGodparentsList-' + safeId);
        data.koumbaros_names = gatherNameList('licKoumbarosList-' + safeId);
        data.parish_ministries = gatherNameList('licMinistriesList-' + safeId);
        data.archdiocesan_honors = gatherNameList('licHonorsList-' + safeId);
      } else if (type === 'diptychs') {
        ['parents','grandparents','siblings_relatives','spiritual_fathers','children_living',
         'grandchildren_living','godchildren_kin','presiding_clergy','deacons_subdeacons',
         'cantors_choir','caregivers','in_memory_of','ministries','outside_charity'].forEach(f => {
          data['dip_' + f] = document.querySelector(`[data-field="dip_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
      } else if (type === 'matriarch-tribute') {
        ['honoree_name','scripture1_ref','scripture1_version','scripture1_text','tribute_text',
         'cherished_traditions','words_lived_by','greatest_joy','promise_text',
         'scripture2_ref','scripture2_version','scripture2_text'].forEach(f => {
          data['mt_' + f] = document.querySelector(`[data-field="mt_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
        const signedByLabels = [];
        [['mt_signed_by_daughter','Daughter'],['mt_signed_by_daughters','Daughters'],['mt_signed_by_son','Son'],['mt_signed_by_sons','Sons']].forEach(([field, label]) => {
          if (document.querySelector(`[data-field="${field}"][data-page-id="${safeId}"]`)?.checked) signedByLabels.push(label);
        });
        data.mt_signed_by = signedByLabels.join(', ');
      } else if (type === 'patriarch-tribute') {
        ['honoree_name','scripture1_ref','scripture1_version','scripture1_text','personal_motto',
         'tribute_text','trade_craft','standard_of_honor','favorite_pastime','promise_text'].forEach(f => {
          data['pt_' + f] = document.querySelector(`[data-field="pt_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
        const ptSignedByLabels = [];
        [['pt_signed_by_daughter','Daughter'],['pt_signed_by_daughters','Daughters'],['pt_signed_by_son','Son'],['pt_signed_by_sons','Sons']].forEach(([field, label]) => {
          if (document.querySelector(`[data-field="${field}"][data-page-id="${safeId}"]`)?.checked) ptSignedByLabels.push(label);
        });
        data.pt_signed_by = ptSignedByLabels.join(', ');
      } else if (type === 'sacramental-life') {
        ['scripture1_ref','scripture1_version','scripture1_text','baptism_date','baptism_parish',
         'godfather_name','godmother_name','communion_date','communion_parish',
         'scripture2_ref','scripture2_version','scripture2_text','confirmation_date',
         'confirmation_parish','confirmation_name','confirmation_sponsor','marriage_date',
         'marriage_parish','spouse_name','years_married','parish_service','last_rites_date'].forEach(f => {
          data['sl_' + f] = document.querySelector(`[data-field="sl_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
      } else if (type === 'universal-prayer') {
        data.up_first_name = document.querySelector(`[data-field="up_first_name"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'catholic-guest-welcome') {
        data.cgw_full_name = document.querySelector(`[data-field="cgw_full_name"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'oraciones-spanish-i') {
        ['name','start_date','gathering_time','location','address'].forEach(f => {
          data['os1_' + f] = document.querySelector(`[data-field="os1_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
      } else if (type === 'guadalupe-devocion-spanish') {
        ['name','start_date','gathering_time','location','address'].forEach(f => {
          data['gds_' + f] = document.querySelector(`[data-field="gds_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
      } else if (type === 'spiritual-bouquets') {
        ['mass_intro_text','parish_name','parish_address','parish_city_state_zip','parish_phone_website','first_name','priest_name','church_name','gratitude_text'].forEach(f => {
          data['sb_' + f] = document.querySelector(`[data-field="sb_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
        data.sb_charities = gatherNameList('sbCharitiesList-' + safeId);
      } else if (type === 'catholic-committal-reception') {
        ['cemetery_name','cemetery_address','cemetery_city_state','committal_quote',
         'reception_intro','reception_venue','reception_address','reception_city_state',
         'acknowledgment_text'].forEach(f => {
          data['ccr_' + f] = document.querySelector(`[data-field="ccr_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
      } else if (type === 'sacred-hymnody') {
        data.sh_brother_sister = document.querySelector(`input[name="shBrotherSister-${safeId}"]:checked`)?.value || '';
      } else if (type === 'memory-eternal') {
        data.me_name = document.querySelector(`[data-field="me_name"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'makaria-meal') {
        ['cemetery_name','cemetery_address','committal_time',
         'reception_location','reception_address','reception_time',
         'scripture_ref','scripture_text'].forEach(f => {
          data['mm_' + f] = document.querySelector(`[data-field="mm_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
        data.mm_ceremonial_choice = document.querySelector(`input[name="mmCeremonialChoice-${safeId}"]:checked`)?.value || 'keep';
        data.mm_ceremonial_custom = document.querySelector(`[data-field="mm_ceremonial_custom"][data-page-id="${safeId}"]`)?.value || '';
        data.mm_makaria_choice = document.querySelector(`input[name="mmMakariaChoice-${safeId}"]:checked`)?.value || 'keep';
        data.mm_makaria_custom = document.querySelector(`[data-field="mm_makaria_custom"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'panikhida-schedule') {
        ['scripture1_ref','scripture1_version','scripture1_text',
         'third_date','third_time','third_location',
         'ninth_date','ninth_time','ninth_location',
         'fortieth_date','fortieth_time','fortieth_location',
         'annual_date','annual_time','annual_location',
         'parish_name','parish_address','clergy_name','parish_office',
         'scripture2_ref','scripture2_version','scripture2_text'].forEach(f => {
          data['ps_' + f] = document.querySelector(`[data-field="ps_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
      } else if (type === 'psalm-23') {
        data.p23_version = document.querySelector(`[data-field="p23_version"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'eccl-3-john-14') {
        data.ej_version = document.querySelector(`[data-field="ej_version"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === '2-timothy-4') {
        data.tt_version = document.querySelector(`[data-field="tt_version"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'psalm-91') {
        data.p91_version = document.querySelector(`[data-field="p91_version"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'lords-prayer') {
        data.lp_version = document.querySelector(`[data-field="lp_version"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'psalm-121') {
        data.p121_version = document.querySelector(`[data-field="p121_version"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'isaiah-40-matthew-11') {
        data.im_version = document.querySelector(`[data-field="im_version"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'romans-8-rev-21') {
        data.rr_version = document.querySelector(`[data-field="rr_version"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === '1-cor-13-2-cor-5') {
        data.cc_version = document.querySelector(`[data-field="cc_version"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'comfort-hope') {
        data.ch_version = document.querySelector(`[data-field="ch_version"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'prov-31-beatitudes') {
        data.pb_version = document.querySelector(`[data-field="pb_version"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'psalm-62-phil-4') {
        data.pp_version = document.querySelector(`[data-field="pp_version"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'john-11-st-francis') {
        data.jf_version = document.querySelector(`[data-field="jf_version"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'custom-text') {
        data.ct_text = document.querySelector(`[data-field="ct_text"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'life-sketch') {
        ['full_name','dob','birthplace','parents','spouse_name','marriage_date','years_married','baptism_date','baptism_location','congregation_privileges','custom_closing','scripture_1_ref','scripture_1_version','scripture_2_ref','scripture_2_version'].forEach(f => {
          data['ls_' + f] = document.querySelector(`[data-field="ls_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
        data.ls_closing_choice = document.querySelector(`input[name="lsClosingChoice-${safeId}"]:checked`)?.value || 'standard';
      } else if (type === 'multi-scripture') {
        data.scripture_version = document.querySelector(`[data-field="scripture_version"][data-page-id="${safeId}"]`)?.value || '';
        const refCount = (multiScriptureConfig[pageId] || []).length;
        for (let i = 1; i <= refCount; i++) {
          data[`scripture_${i}_ref`] = document.querySelector(`[data-field="scripture_${i}_ref"][data-page-id="${safeId}"]`)?.value || '';
        }
      } else if (type === 'family-gratitude') {
        data.gratitude_message = document.querySelector(`[data-field="gratitude_message"][data-page-id="${safeId}"]`)?.value || '';
        data.burial_interment_lines = gatherOosTable('oosTable-' + safeId + '-burial');
        data.gathering_fellowship_lines = gatherOosTable('oosTable-' + safeId + '-gathering');
        data.fg_scripture_ref = document.querySelector(`[data-field="fg_scripture_ref"][data-page-id="${safeId}"]`)?.value || '';
        data.fg_scripture_version = document.querySelector(`[data-field="fg_scripture_version"][data-page-id="${safeId}"]`)?.value || '';
      } else if (type === 'faithful-course') {
        data.fc_scripture_top = document.querySelector(`[data-field="fc_scripture_top"][data-page-id="${safeId}"]`)?.value || '';
        data.fc_scripture_bottom = document.querySelector(`[data-field="fc_scripture_bottom"][data-page-id="${safeId}"]`)?.value || '';
        for (let i = 1; i <= 4; i++) {
          data[`fc_slot_${i}_theme`] = document.querySelector(`[data-field="fc_slot_${i}_theme"][data-page-id="${safeId}"]`)?.value || '';
          data[`fc_slot_${i}_caption`] = document.querySelector(`[data-field="fc_slot_${i}_caption"][data-page-id="${safeId}"]`)?.value || '';
        }
      } else if (type === 'keep-or-replace-sections') {
        const sections = keepOrReplaceConfig[pageId] || [];
        sections.forEach((section, i) => {
          const n = i + 1;
          const choice = document.querySelector(`input[name="korSection${n}-${safeId}"]:checked`)?.value || 'keep';
          data[`kor_section${n}_label`] = section.label;
          data[`kor_section${n}_choice`] = choice;
          if (choice === 'replace') {
            data[`kor_section${n}_replacement_title`] = document.querySelector(`[data-field="kor_section${n}_replacement_title"][data-page-id="${safeId}"]`)?.value || '';
            data[`kor_section${n}_replacement_text`] = document.querySelector(`[data-field="kor_section${n}_replacement_text"][data-page-id="${safeId}"]`)?.value || '';
          }
        });
      } else if (type === 'vigil-rosary') {
        data.vr_location = document.querySelector(`[data-field="vr_location"][data-page-id="${safeId}"]`)?.value || '';
        data.vr_date = document.querySelector(`[data-field="vr_date"][data-page-id="${safeId}"]`)?.value || '';
        data.vr_time = document.querySelector(`[data-field="vr_time"][data-page-id="${safeId}"]`)?.value || '';
        data.vr_presider = document.querySelector(`[data-field="vr_presider"][data-page-id="${safeId}"]`)?.value || '';
        data.introductory_rites_lines = gatherOosTable('oosTable-' + safeId + '-intro');
        data.liturgy_of_word_lines = gatherOosTable('oosTable-' + safeId + '-word');
        data.holy_rosary_lines = gatherOosTable('oosTable-' + safeId + '-rosary');
        data.words_of_remembrance_lines = gatherOosTable('oosTable-' + safeId + '-remembrance');
        data.concluding_rites_lines = gatherOosTable('oosTable-' + safeId + '-concluding');
      } else if (type === 'rite-of-inurnment') {
        ['location_name','location_section','location_city','scripture_ref','celebrant_name','decedent_name','birth_year','death_year','hymn_antiphon','closing_line'].forEach(f => {
          data['ri_' + f] = document.querySelector(`[data-field="ri_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
      } else if (type === 'resolution-of-respect') {
        ['deceased_name','church_name','pastor_at_joining','join_date','submitted_date','pastor_name','clerk_name'].forEach(f => {
          data['ror_' + f] = document.querySelector(`[data-field="ror_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
        data.ror_ministries_served = gatherNameList('ministryList-' + safeId);
      } else if (type === 'service-of-committal') {
        ['cemetery_name','section_plot','city_state','officiant','scripture_ref'].forEach(f => {
          data['soc_' + f] = document.querySelector(`[data-field="soc_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
        data.order_of_committal_lines = gatherOosTable('oosTable-' + safeId);
      } else if (type === 'note-only') {
        // Nothing to capture — page is fixed/printed content, only the universal page_note below applies.
      } else if (type === 'christian-walk') {
        ['salvation_date','baptism_church','officiating_pastor','home_church','pastor_name','years_service','scripture_1_ref','scripture_1_version','scripture_2_ref','scripture_2_version','scripture_3_ref','scripture_3_version'].forEach(f => {
          data['cw_' + f] = document.querySelector(`[data-field="cw_${f}"][data-page-id="${safeId}"]`)?.value || '';
        });
        data.cw_ministry_leadership = gatherNameList('ministryLeadershipList-' + safeId);
        data.cw_community_outreach = gatherNameList('outreachList-' + safeId);
      } else if (type === 'repast-fellowship') {
        data.rf_scripture_ref = document.querySelector(`[data-field="rf_scripture_ref"][data-page-id="${safeId}"]`)?.value || '';
        data.rf_venue_name = document.querySelector(`[data-field="rf_venue_name"][data-page-id="${safeId}"]`)?.value || '';
        data.rf_venue_address = document.querySelector(`[data-field="rf_venue_address"][data-page-id="${safeId}"]`)?.value || '';
        data.rf_venue_city = document.querySelector(`[data-field="rf_venue_city"][data-page-id="${safeId}"]`)?.value || '';
        data.rf_grace_name = document.querySelector(`[data-field="rf_grace_name"][data-page-id="${safeId}"]`)?.value || '';
        data.rf_grace_custom_text = document.querySelector(`[data-field="rf_grace_custom_text"][data-page-id="${safeId}"]`)?.value || '';
        const expressionsChoice = document.querySelector(`input[name="rfExpressionsChoice-${safeId}"]:checked`)?.value || 'keep';
        data.rf_expressions_choice = expressionsChoice;
        if (expressionsChoice === 'replace') {
          data.rf_expressions_replacement = document.querySelector(`[data-field="rf_expressions_replacement"][data-page-id="${safeId}"]`)?.value || '';
        }
      } else if (type === 'expressions-of-gratitude') {
        ['eog_poem', 'eog_message'].forEach(prefix => {
          const choice = document.querySelector(`input[name="${prefix}Choice-${safeId}"]:checked`)?.value || 'keep';
          data[`${prefix}_choice`] = choice;
          if (choice === 'replace') {
            data[`${prefix}_replacement`] = document.querySelector(`[data-field="${prefix}_replacement"][data-page-id="${safeId}"]`)?.value || '';
          }
        });
        data.eog_funeral_home_name = document.querySelector(`[data-field="eog_funeral_home_name"][data-page-id="${safeId}"]`)?.value || '';
        data.eog_funeral_home_city = document.querySelector(`[data-field="eog_funeral_home_city"][data-page-id="${safeId}"]`)?.value || '';
      } else {
        data.tribute_text = document.querySelector(`[data-field="tribute_text"][data-page-id="${safeId}"]`)?.value || '';
      }

      // Universal per-page note, present on every page type
      data.page_note = document.querySelector(`[data-field="page_note"][data-page-id="${safeId}"]`)?.value || '';

      return data;
    }

    async function submitQuestionForm() {
      const nameEl = document.getElementById('questionName');
      const emailEl = document.getElementById('questionEmail');
      const messageEl = document.getElementById('questionMessage');
      const btn = document.getElementById('submitQuestionBtn');
      const statusEl = document.getElementById('questionStatusMsg');

      const name = (nameEl?.value || '').trim();
      const email = (emailEl?.value || '').trim();
      const message = (messageEl?.value || '').trim();

      if (!name || !email || !message) {
        if (statusEl) {
          statusEl.style.display = 'block';
          statusEl.style.color = '#e0b0b0';
          statusEl.textContent = 'Please fill in your name, email, and question before sending.';
        }
        return;
      }

      const payload = {
        form_source: 'Lookbook — Still Have Questions',
        contact_name: name,
        contact_email: email,
        question_message: message,
      };

      if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
      if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#999'; statusEl.textContent = 'Sending your question...'; }

      try {
        const response = await fetch('https://formspree.io/f/xoeqrder', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (response.ok) {
          if (statusEl) { statusEl.style.color = '#9ecb9e'; statusEl.textContent = "Thank you — we've received your question and will be in touch soon."; }
          if (btn) { btn.textContent = 'Sent ✓'; }
          if (nameEl) nameEl.value = '';
          if (emailEl) emailEl.value = '';
          if (messageEl) messageEl.value = '';
        } else {
          throw new Error('Formspree responded with an error');
        }
      } catch (err) {
        if (statusEl) { statusEl.style.color = '#e0b0b0'; statusEl.textContent = 'Something went wrong sending your question. Please try again, or email us directly.'; }
        if (btn) { btn.disabled = false; btn.textContent = 'Send Question'; }
      }
    }

    async function submitPageSelections() {
      const pageIds = Object.keys(selectedPages);
      const statusEl = document.getElementById('submitStatusMsg');
      const btn = document.getElementById('submitSelectionsBtn');

      if (!selectedTier) {
        alert('Please choose your program size first.');
        return;
      }
      if (pageIds.length === 0) {
        alert('Please select at least one page before submitting.');
        return;
      }

      const name = document.getElementById('contactName')?.value || '';
      const email = document.getElementById('contactEmail')?.value || '';
      const phone = document.getElementById('contactPhone')?.value || '';
      const serviceDate = document.getElementById('contactServiceDate')?.value || '';
      const orderNumber = document.getElementById('contactOrderNumber')?.value || '';
      const notes = document.getElementById('contactNotes')?.value || '';

      if (!name || !email) {
        alert('Please fill in at least your name and email so we can reach you about your program.');
        return;
      }
      if (!orderNumber.trim()) {
        alert("You'll need an order number from your Done-For-You purchase to submit. If you haven't purchased yet, that's okay — click \"Save & finish later\" instead. We'll email you a link so you can complete your purchase and come right back to finish submitting.");
        document.getElementById('contactOrderNumber')?.focus();
        return;
      }

      const orderValid = pageIds.every(pid => pageOrderAssignments[pid] !== undefined) &&
        new Set(Object.values(pageOrderAssignments)).size === pageIds.length;
      if (!orderValid) {
        alert('Please give every selected page a unique position number before submitting.');
        document.getElementById('pageOrderWarning')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const spellcheckPref = document.querySelector('input[name="spellcheckPref"]:checked')?.value || 'not specified';
      const reviewConfirmed = document.getElementById('reviewConfirmedCheckbox')?.checked;
      if (!reviewConfirmed) {
        alert('Please confirm you have reviewed your selections (checkbox near the bottom) before submitting.');
        return;
      }

      // Blank fields show clearly as "— not provided —" in the email, rather than looking
      // identical to a label with nothing after it — makes real gaps easy to spot at a glance.
      const displayVal = (v) => (v && String(v).trim()) ? v : '— not provided —';

      const payload = {
        form_source: 'Lookbook Page Selection',
        order_number: orderNumber,
        tier_selected: selectedTier + '-Page Program',
        format_selected: selectedFormat === 'tabloid' ? '11x17" (folds to 8.5x11")' : '8.5x11" (folds to 5.5x8.5") — Standard',
        page_budget: pageBudget,
        pages_selected_count: pageIds.length,
        contact_name: name,
        contact_email: email,
        contact_phone: displayVal(phone),
        service_date: displayVal(serviceDate),
        additional_notes: displayVal(notes),
        spellcheck_preference: spellcheckPref,
      };

      // Submit pages in their assigned book order, not selection order
      const orderedPageIds = [...pageIds].sort((a, b) => pageOrderAssignments[a] - pageOrderAssignments[b]);
      orderedPageIds.forEach(pid => {
        const position = pageOrderAssignments[pid];
        const title = selectedPages[pid].title;
        const fields = gatherPageFieldData(pid);
        payload[`page_${position}_name`] = title;
        Object.keys(fields).forEach(k => {
          payload[`page_${position}_${k}`] = displayVal(fields[k]);
        });
      });

      if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
      if (statusEl) { statusEl.style.display = 'block'; statusEl.style.color = '#999'; statusEl.textContent = 'Sending your selections...'; }

      try {
        const response = await fetch('https://formspree.io/f/xoeqrder', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (response.ok) {
          if (statusEl) { statusEl.style.color = '#9ecb9e'; statusEl.textContent = 'Thank you — your selections have been sent. We will be in touch soon.'; }
          if (btn) { btn.textContent = 'Submitted ✓'; }
          clearSavedProgress();
          deleteProgressRemote();
        } else {
          throw new Error('Formspree responded with an error');
        }
      } catch (err) {
        if (statusEl) { statusEl.style.color = '#e0b0b0'; statusEl.textContent = 'Something went wrong sending your selections. Please try again, or email us directly.'; }
        if (btn) { btn.disabled = false; btn.textContent = 'Submit My Selections'; }
      }
    }

    const lookbookSlides = document.querySelectorAll('.lookbook-wrapper .slide');
    const lookbookJumpBtns = document.querySelectorAll('.lookbook-wrapper .jump-btn');
    const lookbookCounter = document.querySelector('.lookbook-wrapper #counter');

    const TRACK_A_LENGTH = 12; // Title, Tier Select, 9 categories, Your Selected Pages — the selection tool itself
    // Track B (indices 12+) is reference material, reached only via pills — Next/Previous never lands there automatically

    function showLookbookSlide(index) {
      if (!lookbookSlides.length) return;

      // Remember where we were in the tool before leaving it for a reference slide
      if (lookbookCurrentSlide < TRACK_A_LENGTH) {
        lastToolSlide = lookbookCurrentSlide;
      }

      lookbookSlides[lookbookCurrentSlide].classList.remove('active');
      // Clear ALL jump-nav buttons' active state (not just the previous slide's) so a stale
      // highlight can't linger when jumping to a reference slide that has no button of its own.
      lookbookJumpBtns.forEach(btn => { if (btn) btn.classList.remove('active'); });

      // Track B slides (>= TRACK_A_LENGTH) are not wrapped/cycled — go there directly, no modulo wraparound
      if (index >= TRACK_A_LENGTH) {
        lookbookCurrentSlide = Math.min(index, lookbookSlides.length - 1);
      } else {
        // Track A wraps only within itself (0 to TRACK_A_LENGTH-1)
        lookbookCurrentSlide = ((index % TRACK_A_LENGTH) + TRACK_A_LENGTH) % TRACK_A_LENGTH;
      }

      lookbookSlides[lookbookCurrentSlide].classList.add('active');
      if (lookbookCurrentSlide < lookbookJumpBtns.length && lookbookJumpBtns[lookbookCurrentSlide]) {
        lookbookJumpBtns[lookbookCurrentSlide].classList.add('active');
      }
      if (lookbookCounter) {
        if (lookbookCurrentSlide < TRACK_A_LENGTH) {
          lookbookCounter.textContent = `STEP ${lookbookCurrentSlide + 1} OF ${TRACK_A_LENGTH}`;
        } else {
          lookbookCounter.textContent = `REFERENCE GUIDE ${lookbookCurrentSlide - TRACK_A_LENGTH + 1} OF ${lookbookSlides.length - TRACK_A_LENGTH}`;
        }
      }
      const trackABtns = document.getElementById('trackANavButtons');
      const trackBBtns = document.getElementById('trackBNavButtons');
      const persistentSaveBar = document.getElementById('persistentSaveBar');
      if (trackABtns && trackBBtns) {
        const inTrackB = lookbookCurrentSlide >= TRACK_A_LENGTH;
        const onSelectedPagesSlide = lookbookCurrentSlide === 11;
        trackABtns.style.display = (inTrackB || onSelectedPagesSlide) ? 'none' : '';
        trackBBtns.style.display = inTrackB ? '' : 'none';
        // The persistent bar duplicates the save button already on the
        // Selected Pages slide's contact card, and doesn't apply to Track B
        // (reference material) — hidden in both cases to avoid redundancy/confusion.
        if (persistentSaveBar) {
          persistentSaveBar.style.display = (inTrackB || onSelectedPagesSlide) ? 'none' : 'flex';
        }
      }
      saveProgress();
    }

    function changeLookbookSlide(delta) {
      // Next/Previous only ever moves within Track A (the selection tool) and wraps there.
      if (lookbookCurrentSlide >= TRACK_A_LENGTH) return;
      const nextIndex = ((lookbookCurrentSlide + delta) % TRACK_A_LENGTH + TRACK_A_LENGTH) % TRACK_A_LENGTH;
      showLookbookSlide(nextIndex);
    }

    function changeReferenceSlide(delta) {
      // Next/Previous among the 7 reference slides only (Track B), wraps within itself.
      if (lookbookCurrentSlide < TRACK_A_LENGTH) return;
      const refLength = lookbookSlides.length - TRACK_A_LENGTH;
      const currentRefIndex = lookbookCurrentSlide - TRACK_A_LENGTH;
      const nextRefIndex = ((currentRefIndex + delta) % refLength + refLength) % refLength;
      showLookbookSlide(TRACK_A_LENGTH + nextRefIndex);
    }

    function returnToTool() {
      showLookbookSlide(lastToolSlide);
    }

    /* LIGHTBOX MODAL CONTROLS */
    function openLookbookModal(imgSrc, titleText) {
      const modal = document.getElementById('lookbookModal');
      const img = document.getElementById('modalImg');
      const title = document.getElementById('modalTitle');
      if (modal && img && title) {
        img.src = imgSrc;
        title.textContent = titleText;
        modal.classList.add('active');
      }
    }

    function closeLookbookModal(e) {
      const modal = document.getElementById('lookbookModal');
      if (modal) {
        modal.classList.remove('active');
      }
    }

    function closeLookbookModalDirect() {
      const modal = document.getElementById('lookbookModal');
      if (modal) {
        modal.classList.remove('active');
      }
    }

    // Debounced autosave whenever the customer types in any field (obituary text, contact info, OOS rows, etc.)
    // This is LOCAL ONLY (localStorage) — remote save + resume email only happen
    // when the customer clicks "Save & finish later", never automatically.
    let autosaveTypingTimer = null;
    document.addEventListener('input', (e) => {
      const wrapper = document.querySelector('.lookbook-wrapper');
      if (!wrapper || !wrapper.contains(e.target)) return;
      if (e.target.matches('.review-field-input, #contactName, #contactPhone, #contactEmail, #contactServiceDate, #contactOrderNumber, #contactNotes')) {
        clearTimeout(autosaveTypingTimer);
        autosaveTypingTimer = setTimeout(saveProgress, 500);
      }
    });

    // Restore any saved progress as soon as the page is ready — a resume link
    // (?resume=...) always wins over whatever's sitting in this browser's
    // localStorage, since the customer explicitly clicked a link to pick up
    // a specific saved session.
    function initLookbookProgress() {
      const params = new URLSearchParams(window.location.search);
      if (params.get('resume')) {
        checkForResumeLink();
      } else {
        restoreProgress();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLookbookProgress);
    } else {
      initLookbookProgress();
    }

    document.addEventListener('keydown', (e) => {
      const wrapper = document.querySelector('.lookbook-wrapper');
      if (!wrapper) return;
      // Never hijack keystrokes while the user is typing in a field — a space or arrow key
      // while writing a name, prayer text, or acknowledgment should never trigger slide navigation.
      const tag = e.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || e.target.isContentEditable) {
        if (e.key === 'Escape') {
          closeLookbookModalDirect();
        }
        return;
      }
      if (e.key === 'Escape') {
        closeLookbookModalDirect();
      }
      if (!document.getElementById('lookbookModal').classList.contains('active')) {
        if (e.key === 'ArrowRight' || e.key === ' ') {
          e.preventDefault();
          changeLookbookSlide(1);
        }
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          changeLookbookSlide(-1);
        }
      }
    });